import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import authStorage from "../../service/authStorage";
import Accordion from "react-bootstrap/Accordion";
import PropertyDoubleInput from "./PropertyDoubleInput";
import PropertyEnumInput from "./PropertyEnumInput";
import PropertyCheckInput from "./PropertyCheckInput";
import PropertyDate from "./PropertyDate";
import PropertyTextArea from "./PropertyTextArea";
import { useDispatch } from "react-redux/es/hooks/useDispatch";
import { useSelector } from "react-redux/es/exports";
import AccordionItem from "react-bootstrap/esm/AccordionItem";
import DemandForecastChart from "../../charts/DemandForecastChart";
import headerService from "../../service/headerService";
import findDemandForecastMaxValue from "../../service/findDemandForecastMaxValue";
import axios from "axios";
import axiosBaseUrl from "../../api/axiosBaseURL";
import ModalUploadFile from "../treeModalWindows/ModalUploadFile";
import ModalDelete from "../treeModalWindows/ModalDelete";
import ModalGenerateDemand from "../treeModalWindows/ModalGenerateDemand";
import ModalGenerateForecast from "../treeModalWindows/ModalGenerateForecast";
import PROPERTY_LIMITATIONS from "../../json/PropertyLimitations.json";
import SmallButton from "../../ui/SmallButton";
import PropertyService from "./PropertyService";
import ModalGenerateDistribution from "../treeModalWindows/ModalGenerateDistribution";
import parseDistribution from "../../service/parseDistribution";

const PropertyPanel = (props) => {
  const BEARER = authStorage();
  const navigate = useNavigate();

  const [ruleType, setRuleType] = useState();

  //General
  const [name, setName] = useState();
  const [description, setDescription] = useState();

  const [beginDate, setBeginDate] = useState();
  const [endDate, setEndDate] = useState();
  const [initialInventory, setInitialInventory] = useState();
  //errors
  const [dateError, setDateError] = useState();
  const [nameError, setNameError] = useState();
  const [initialInventoryError, setInitialInventoryError] = useState();

  // RuleFragment ---------------------------------
  // ordering parameters
  const [ruleFragment, setRuleFragment] = useState();
  const [orderingFrequency, setOrderingFrequency] = useState();
  const [minOrderQuantity, setMinOrderQuantity] = useState();
  const [orderingQuantum, setOrderingQuantum] = useState();
  // errors
  const [orderingFrequencyError, setOrderingFrequencyError] = useState();
  const [minOrderQuantityError, setMinOrderQuantityError] = useState();
  const [orderingQuantumError, setOrderingQuantumError] = useState();

  // DdmrpRuleFragment ---------------------------------
  // advanced parameters
  const [ddmrpRuleFragment, setDdmrpRuleFragment] = useState();
  const [zoneQuantum, setZoneQuantum] = useState();
  const [recalculationFrequency, setRecalculationFrequency] = useState();
  const [considerationPeriod, setConsiderationPeriod] = useState();
  const [forwardConsideration, setForwardConsideration] = useState();
  const [variabilityFactor, setVariabilityFactor] = useState();
  const [redZoneLeadTimeFactor, setRedZoneLeadTimeFactor] = useState();
  const [greenZoneLeadTimeFactor, setGreenZoneLeadTimeFactor] = useState();
  const [isConsiderPreOrders, setIsConsiderPreOrders] = useState();
  const [qualifiedSpikeHorizon, setQualifiedSpikeHorizon] = useState();
  const [
    qualifiedSpikeSizeFractionTopOfRed,
    setQualifiedSpikeSizeFractionTopOfRed,
  ] = useState();
  const [isRecalculateDLT, setIsRecalculateDLT] = useState();
  const [dltRecalculationHorizonDLTs, setDltRecalculationHorizonDLTs] =
    useState();
  // errors
  const [zoneQuantumError, setZoneQuantumError] = useState();
  const [recalculationFrequencyError, setRecalculationFrequencyError] =
    useState();
  const [considerationPeriodError, setConsiderationPeriodError] = useState();
  const [forwardConsiderationError, setForwardConsiderationError] = useState();
  const [variabilityFactorError, setVariabilityFactorError] = useState();
  const [redZoneLeadTimeFactorError, setRedZoneLeadTimeFactorError] =
    useState();
  const [greenZoneLeadTimeFactorError, setGreenZoneLeadTimeFactorError] =
    useState();
  const [qualifiedSpikeHorizonError, setQualifiedSpikeHorizonError] =
    useState();
  const [
    qualifiedSpikeSizeFractionTopOfRedError,
    setQualifiedSpikeSizeFractionTopOfRedError,
  ] = useState();
  const [
    dltRecalculationHorizonDLTsError,
    setDltRecalculationHorizonDLTsError,
  ] = useState();

  // TocRuleFragment ---------------------------------
  // advanced parameters
  const [tocRuleFragment, setTocRuleFragment] = useState();
  const [tslRedLevel, setTslRedLevel] = useState();
  const [tslYellowLevel, setTslYellowLevel] = useState();
  const [absoluteMinimumTSL, setAbsoluteMinimumTSL] = useState();
  const [tslRoundingMultiple, setTslRoundingMultiple] = useState();
  // errors
  const [tslRedLevelError, setTslRedLevelError] = useState();
  const [tslYellowLevelError, setTslYellowLevelError] = useState();
  const [absoluteMinimumTSLError, setAbsoluteMinimumTSLError] = useState();
  const [tslRoundingMultipleError, setTslRoundingMultipleError] = useState();

  // initial TSL parameters
  const [initialTSLCalculationRuleType, setInitialTSLCalculationRuleType] =
    useState();
  const [
    initialTSLCalculationAggregationType,
    setInitialTSLCalculationAggregationType,
  ] = useState();
  const [
    initialTSLCalculationWindowSizeRRTs,
    setInitialTSLCalculationWindowSizeRRTs,
  ] = useState();
  // errors
  const [
    initialTSLCalculationWindowSizeRRTsError,
    setInitialTSLCalculationWindowSizeRRTsError,
  ] = useState();

  // hybrid parameters
  const [isUseHybridRule, setIsUseHybridRule] = useState();
  const [hybridAdjustmentHorizonRRTs, setHybridAdjustmentHorizonRRTs] =
    useState();
  const [hybridIncreaseThreshold, setHybridIncreaseThreshold] = useState();
  const [hybridDecreaseThreshold, setHybridDecreaseThreshold] = useState();
  // errors
  const [
    hybridAdjustmentHorizonRRTsError,
    setHybridAdjustmentHorizonRRTsError,
  ] = useState();
  const [hybridIncreaseThresholdError, setHybridIncreaseThresholdError] =
    useState();
  const [hybridDecreaseThresholdError, setHybridDecreaseThresholdError] =
    useState();

  // PenetrationTocRuleFragment ---------------------------------
  // penetration based TSL calculation
  const [penetrationTocRuleFragment, setPenetrationTocRuleFragment] =
    useState();
  const [targetBufferIncreasePercent, setTargetBufferIncreasePercent] =
    useState();
  const [targetBufferDecreasePercent, setTargetBufferDecreasePercent] =
    useState();
  const [redSlidingWindowSizeInRRTs, setRedSlidingWindowSizeInRRTs] =
    useState();
  const [greenSlidingWindowSizeInRRTs, setGreenSlidingWindowSizeInRRTs] =
    useState();
  const [redToleranceTimeInRRTs, setRedToleranceTimeInRRTs] = useState();
  const [redPenetrationThreshold, setRedPenetrationThreshold] = useState();
  const [redPenetrationCountingCriteria, setRedPenetrationCountingCriteria] =
    useState();
  // errors
  const [
    targetBufferIncreasePercentError,
    setTargetBufferIncreasePercentError,
  ] = useState();
  const [
    targetBufferDecreasePercentError,
    setTargetBufferDecreasePercentError,
  ] = useState();
  const [redSlidingWindowSizeInRRTsError, setRedSlidingWindowSizeInRRTsError] =
    useState();
  const [
    greenSlidingWindowSizeInRRTsError,
    setGreenSlidingWindowSizeInRRTsError,
  ] = useState();
  const [redToleranceTimeInRRTsError, setRedToleranceTimeInRRTsError] =
    useState();
  const [redPenetrationThresholdError, setRedPenetrationThresholdError] =
    useState();

  // PenetrationTocWithSmallTslRuleFragment ---------------------------------
  // penetration from SmallTSLRule
  const [
    penetrationTocWithSmallTslRuleFragment,
    setPenetrationTocWithSmallTslRuleFragment,
  ] = useState();
  const [useRedDaysBasedRuleForTSLBelow, setUseRedDaysBasedRuleForTSLBelow] =
    useState();
  const [
    redDaysBackwardLookingHorizonRRTs,
    setRedDaysBackwardLookingHorizonRRTs,
  ] = useState();
  const [redDaysNumberToIncreaseTSL, setRedDaysNumberToIncreaseTSL] =
    useState();
  const [greenPeriodToDecreaseTSLRRTs, setGreenPeriodToDecreaseTSLRRTs] =
    useState();
  const [
    waitingPeriodBeforeCheckingToIncreaseTSLRRTs,
    setWaitingPeriodBeforeCheckingToIncreaseTSLRRTs,
  ] = useState();
  // errors
  const [
    useRedDaysBasedRuleForTSLBelowError,
    setUseRedDaysBasedRuleForTSLBelowError,
  ] = useState();
  const [
    redDaysBackwardLookingHorizonRRTsError,
    setRedDaysBackwardLookingHorizonRRTsError,
  ] = useState();
  const [redDaysNumberToIncreaseTSLError, setRedDaysNumberToIncreaseTSLError] =
    useState();
  const [
    greenPeriodToDecreaseTSLRRTsError,
    setGreenPeriodToDecreaseTSLRRTsError,
  ] = useState();
  const [
    waitingPeriodBeforeCheckingToIncreaseTSLRRTsError,
    setWaitingPeriodBeforeCheckingToIncreaseTSLRRTsError,
  ] = useState();

  // ConsumptionTocRuleFragment ---------------------------------
  // parameters from ConsumptionTocRuleFragment
  const [consumptionTocRuleFragment, setConsumptionTocRuleFragment] =
    useState();
  const [consumptionAggregationType, setConsumptionAggregationType] =
    useState();
  const [consumptionTimeWindowRRTs, setConsumptionTimeWindowRRTs] = useState();
  // errors
  const [consumptionTimeWindowRRTsError, setConsumptionTimeWindowRRTsError] =
    useState();

  // Demand and Forecast ---------------------------------
  // demand
  const [demandForecast, setDemandForecast] = useState({});
  const [maxDemandForecastValue, setMaxDemandForecastValue] = useState();
  const [isNeedUpdateDemandForecastPlot, setIsNeedUpdateDemandForecastPlot] =
    useState();
  const [totalDemand, setTotalDemand] = useState();
  const [totalDemandString, setTotalDemandString] = useState();

  const [isDemandInitialMode, setIsDemandInitialMode] = useState(true);
  const [isDemandGenerateMode, setIsDemandGenerateMode] = useState(false);
  const [isShowGenerateDemandModalWindow, setIsShowGenerateDemandModalWindow] =
    useState();
  const [isNeedGenerateDemandRequest, setIsNeedGenerateDemandRequest] =
    useState();
  const [generateDemandRequestDTO, setGenerateDemandRequestDTO] = useState({
    demandDistribution: "CONSTANT",
    totalDemand: undefined,
    variability: undefined,
  });
  const GENERATE_DEMAND = "Demand properties and demand distribution profile";
  const [days, setDays] = useState();
  const [variability, setVariability] = useState("NO");

  // forecast
  const [
    isShowGenerateForecastModalWindow,
    setIsShowGenerateForecastModalWindow,
  ] = useState();
  const [isForecastInitialMode, setIsForecastInitialMode] = useState(true);
  const [isForecastGenerateMode, setIsForecastGenerateMode] = useState(false);
  const GENERATE_FORECAST = "Specify forecast properties";
  const [forecastingError, setForecastingError] = useState(0.0);
  const [isNeedGenerateForecastRequest, setIsNeedGenerateForecastRequest] =
    useState();

  const [isNeedNoForecastRequest, setIsNeedNoForecastRequest] = useState();
  const [isNeedSaveGeneratedDemand, setIsNeedSaveGeneratedDemand] = useState();
  const [isNeedSaveGeneratedForecast, setIsNeedSaveGeneratedForecast] =
    useState();

  const DEMAND_FORECAST_POSTFIX = "/demand-forecast";
  const DEMAND_POSTFIX = "/demand";
  const FORECAST_POSTFIX = "/forecast";
  const FILE_POSTFIX = "/file";
  const [file, setFile] = useState();
  const [requestPath, setRequestPath] = useState();
  const [isShowUploadFileWindow, setIsShowUploadFileWindow] = useState();
  const [uploadTemplateTitle, setUploadTemplateTitle] = useState();
  const [isNeedToUploadFile, setIsNeedToUploadFile] = useState();
  const [isShowDeleteForecastWindow, setIsShowDeleteForecastWindow] =
    useState();
  const DELETE_FORECAST = `Delete all forecast data from scenario?`;
  const DELETE_BUTTON_TITLE = "DELETE FORECAST";

  // errors
  const [isNeedUpdateData, setIsNeedUpdateData] = useState(false);

  const [errorMsg, setErrorMsg] = useState();
  const [hasAnyErrors, setHasAnyErrors] = useState(false);
  const [isCleanErrors, setIsCleanErrors] = useState();

  const SCENARIOS_URL = process.env.REACT_APP_ARI_URL + "/scenarios/";

  const isTemplateCurrentScenario = useSelector(
    (state) => state?.isTemplateCurrentScenario
  );
  const isNeedGetScenarioProperties = useSelector(
    (state) => state?.isNeedGetScenarioProperties
  );
  const scenarioSimulateID = useSelector((state) => state?.scenarioId);
  const templateSimulateID = useSelector((state) => state?.templateId);
  const isNeedSendToServerNewProperties = useSelector(
    (state) => state?.isNeedSendToServerNewProperties
  );
  const dispatch = useDispatch();
  const [uploadButtonTitle, setUploadButtonTitle] = useState();

  // distribution
  const [distribution, setDistribution] = useState({
    type: undefined,
    name: undefined,
    value: undefined,
    mean: undefined,
    sigma: undefined,
    min: undefined,
    max: undefined,
    likely: undefined,
  });

  const currentDistribution = useSelector(
    (state) => state?.currentDistribution
  );

  // const [distributionPattern, setDistributionPattern] = useState()
  const [isShowDistributionWindow, setIsShowDistributionWindow] = useState();
  const [isNeedDistributionRequest, setIsNeedDistributionRequest] = useState();
  const DISTRIBUTION_POSTFIX = "/distribution";
  const [isNeedDistributionPostRequest, setIsNeedDistributionPostRequest] =
    useState();
  const isChangedCurrentScenario = useSelector(
    (state) => state?.isChangedCurrentScenario
  );
  const [isLoading, setIsLoading] = useState(true);
  const isNeedRefreshSimulation = useSelector(
    (state) => state?.isNeedRefreshSimulation
  );
  useEffect(() => {
    showRedStarEditionMode(props?.editMode);
  }, [props.editMode]);

  useEffect(() => {
    if (!isNeedRefreshSimulation) {
      setIsDemandGenerateMode(false);
      setIsDemandInitialMode(true);
      setIsForecastGenerateMode(false);
      setIsForecastInitialMode(true);
    } else {
      return;
    }
  }, [isNeedRefreshSimulation]);

  // redirect without auth
  const redirectIfNotAuth = (response) => {
    if (response.status === 401) {
      navigate("/login");
    }
  };

  // hide scenarios and folders context menu buttons,
  // when send request or close modal windows
  const hideAllContextButtons = () => {
    dispatch({
      type: "SET_IS_SHOW_BUTTONS_GROUP",
      payload: "",
    });
    dispatch({
      type: "SET_IS_SHOW_FOLDER_CONTEXT_MENU",
      payload: "",
    });
  };

  // reset
  const fullReset = () => {
    setRequestPath();
    dispatch({
      type: "SEND TO SERVER NEW PROPERTIES",
      payload: false,
    });
    setIsNeedUpdateDemandForecastPlot(false);
  };

  // update flag
  useEffect(() => {
    setIsNeedUpdateData(false);
  }, [isNeedUpdateData]);

  // update flag
  useEffect(() => {
    setHasAnyErrors(hasAnyErrors);
  }, [hasAnyErrors]);

  // check any input errors
  useEffect(() => {
    const errors = [
      initialInventoryError,
      nameError,
      dateError,
      orderingFrequencyError,
      minOrderQuantityError,
      orderingQuantumError,
      tslRedLevelError,
      tslYellowLevelError,
      absoluteMinimumTSLError,
      tslRoundingMultipleError,
      initialTSLCalculationWindowSizeRRTsError,
      hybridAdjustmentHorizonRRTsError,
      hybridIncreaseThresholdError,
      hybridDecreaseThresholdError,
      zoneQuantumError,
      recalculationFrequencyError,
      considerationPeriodError,
      forwardConsiderationError,
      variabilityFactorError,
      redZoneLeadTimeFactorError,
      greenZoneLeadTimeFactorError,
      qualifiedSpikeHorizonError,
      qualifiedSpikeSizeFractionTopOfRedError,
      dltRecalculationHorizonDLTsError,
      targetBufferIncreasePercentError,
      targetBufferDecreasePercentError,
      redSlidingWindowSizeInRRTsError,
      greenSlidingWindowSizeInRRTsError,
      redToleranceTimeInRRTsError,
      redPenetrationThresholdError,
      useRedDaysBasedRuleForTSLBelowError,
      redDaysBackwardLookingHorizonRRTsError,
      redDaysNumberToIncreaseTSLError,
      greenPeriodToDecreaseTSLRRTsError,
      waitingPeriodBeforeCheckingToIncreaseTSLRRTsError,
      consumptionTimeWindowRRTsError,
    ];
    const filteredErr = errors.filter((error) => error !== undefined);
    if (filteredErr.length > 0) {
      setHasAnyErrors(true);
    } else {
      setHasAnyErrors(false);
    }
  }, [
    initialInventoryError,
    nameError,
    dateError,
    orderingFrequencyError,
    minOrderQuantityError,
    orderingQuantumError,
    tslRedLevelError,
    tslYellowLevelError,
    absoluteMinimumTSLError,
    tslRoundingMultipleError,
    initialTSLCalculationWindowSizeRRTsError,
    hybridAdjustmentHorizonRRTsError,
    hybridIncreaseThresholdError,
    hybridDecreaseThresholdError,
    zoneQuantumError,
    recalculationFrequencyError,
    considerationPeriodError,
    forwardConsiderationError,
    variabilityFactorError,
    redZoneLeadTimeFactorError,
    greenZoneLeadTimeFactorError,
    qualifiedSpikeHorizonError,
    qualifiedSpikeSizeFractionTopOfRedError,
    dltRecalculationHorizonDLTsError,
    targetBufferIncreasePercentError,
    targetBufferDecreasePercentError,
    redSlidingWindowSizeInRRTsError,
    greenSlidingWindowSizeInRRTsError,
    redToleranceTimeInRRTsError,
    redPenetrationThresholdError,
    useRedDaysBasedRuleForTSLBelowError,
    redDaysBackwardLookingHorizonRRTsError,
    redDaysNumberToIncreaseTSLError,
    greenPeriodToDecreaseTSLRRTsError,
    waitingPeriodBeforeCheckingToIncreaseTSLRRTsError,
    consumptionTimeWindowRRTsError,
  ]);

  // clear errors
  useEffect(() => {
    setInitialInventoryError();
    setOrderingFrequencyError();
    setMinOrderQuantityError();
    setOrderingQuantumError();
    setTslRedLevelError();
    setDateError();
    setTslYellowLevelError();
    setAbsoluteMinimumTSLError();
    setTslRoundingMultipleError();
    setInitialTSLCalculationWindowSizeRRTsError();
    setHybridAdjustmentHorizonRRTsError();
    setHybridIncreaseThresholdError();
    setHybridDecreaseThresholdError();
    setZoneQuantumError();
    setRecalculationFrequencyError();
    setConsiderationPeriodError();
    setForwardConsiderationError();
    setVariabilityFactorError();
    setRedZoneLeadTimeFactorError();
    setGreenZoneLeadTimeFactorError();
    setQualifiedSpikeHorizonError();
    setQualifiedSpikeSizeFractionTopOfRedError();
    setDltRecalculationHorizonDLTsError();
    setTargetBufferIncreasePercentError();
    setTargetBufferDecreasePercentError();
    setRedSlidingWindowSizeInRRTsError();
    setGreenSlidingWindowSizeInRRTsError();
    setRedToleranceTimeInRRTsError();
    setRedPenetrationThresholdError();
    setUseRedDaysBasedRuleForTSLBelowError();
    setRedDaysBackwardLookingHorizonRRTsError();
    setRedDaysNumberToIncreaseTSLError();
    setGreenPeriodToDecreaseTSLRRTsError();
    setWaitingPeriodBeforeCheckingToIncreaseTSLRRTsError();
    setConsumptionTimeWindowRRTsError();
    setIsCleanErrors(false);
  }, [isCleanErrors]);

  // get properties from server
  useEffect(() => {
    if (scenarioSimulateID > 0 || templateSimulateID > 0) {
      const simId =
        scenarioSimulateID > 0 ? scenarioSimulateID : templateSimulateID;
      const fetchProps = async () => {
        try {
          const response = await fetch(SCENARIOS_URL + simId, {
            method: "GET",
            headers: headerService(),
          });
          if (response.status === 401) {
            navigate("/login");
          }
          const items = await response.json();
          resolveDTO(items);
          setIsLoading(false);
          setIsNeedUpdateDemandForecastPlot(true);
          dispatch({
            type: "SEND TO SERVER NEW PROPERTIES",
            payload: false,
          });
          dispatch({
            type: "IS_CHANGED_CURRENT_SCENARIO",
            payload: false,
          });
          dispatch({
            type: "GET SCENARIO PROPERTIES",
            payload: false,
          });
        } catch (error) {
          setErrorMsg(error.message);
        }
      };
      fetchProps();
      fullReset();
      setIsNeedDistributionRequest(true);
    }
  }, [props.simulatedId, scenarioSimulateID, isNeedGetScenarioProperties]);

  // send new properties to server
  useEffect(() => {
    if (!isNeedSendToServerNewProperties) {
      return;
    }

    const dto = {
      name: name,
      beginDate: beginDate,
      endDate: endDate,
      description: description,
      initialInventory: initialInventory,
      ruleType: ruleType,
      ruleFragmentDTO: {
        orderingFrequency: orderingFrequency,
        minOrderQuantity: minOrderQuantity,
        orderingQuantum: orderingQuantum,
      },
      tocRuleFragmentDTO: {
        tslRedLevel: tslRedLevel,
        tslYellowLevel: tslYellowLevel,
        absoluteMinimumTSL: absoluteMinimumTSL,
        tslRoundingMultiple: tslRoundingMultiple,
        initialTSLCalculationRuleType: initialTSLCalculationRuleType,
        initialTSLCalculationAggregationType:
          initialTSLCalculationAggregationType,
        initialTSLCalculationWindowSizeRRTs:
          initialTSLCalculationWindowSizeRRTs,
        useHybridRule: isUseHybridRule,
        hybridAdjustmentHorizonRRTs: hybridAdjustmentHorizonRRTs,
        hybridIncreaseThreshold: hybridIncreaseThreshold,
        hybridDecreaseThreshold: hybridDecreaseThreshold,
      },
      ddmrpRuleFragmentDTO: {
        zoneQuantum: zoneQuantum,
        recalculationFrequency: recalculationFrequency,
        considerationPeriod: considerationPeriod,
        forwardConsideration: forwardConsideration,
        variabilityFactor: variabilityFactor,
        redZoneLeadTimeFactor: redZoneLeadTimeFactor,
        greenZoneLeadTimeFactor: greenZoneLeadTimeFactor,
        considerPreOrders: isConsiderPreOrders,
        qualifiedSpikeHorizon: qualifiedSpikeHorizon,
        qualifiedSpikeSizeFractionTopOfRed: qualifiedSpikeSizeFractionTopOfRed,
        recalculateDLT: isRecalculateDLT,
        dltRecalculationHorizonDLTs: dltRecalculationHorizonDLTs,
      },
      penetrationTocRuleFragmentDTO: {
        targetBufferIncreasePercent: targetBufferIncreasePercent,
        targetBufferDecreasePercent: targetBufferDecreasePercent,
        redSlidingWindowSizeInRRTs: redSlidingWindowSizeInRRTs,
        greenSlidingWindowSizeInRRTs: greenSlidingWindowSizeInRRTs,
        redToleranceTimeInRRTs: redToleranceTimeInRRTs,
        redPenetrationThreshold: redPenetrationThreshold,
        redPenetrationCountingCriteria: redPenetrationCountingCriteria,
      },
      penetrationTocWithSmallTslRuleFragmentDTO: {
        useRedDaysBasedRuleForTSLBelow: useRedDaysBasedRuleForTSLBelow,
        redDaysBackwardLookingHorizonRRTs: redDaysBackwardLookingHorizonRRTs,
        redDaysNumberToIncreaseTSL: redDaysNumberToIncreaseTSL,
        greenPeriodToDecreaseTSLRRTs: greenPeriodToDecreaseTSLRRTs,
        waitingPeriodBeforeCheckingToIncreaseTSLRRTs:
          waitingPeriodBeforeCheckingToIncreaseTSLRRTs,
      },
      consumptionTocRuleFragmentDTO: {
        consumptionAggregationType: consumptionAggregationType,
        consumptionTimeWindowRRTs: consumptionTimeWindowRRTs,
      },
    };

    if (scenarioSimulateID > 0) {
      const updateProperty = async () => {
        try {
          const response = await fetch(SCENARIOS_URL + scenarioSimulateID, {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: BEARER,
            },
            body: JSON.stringify(dto),
          })
            .then(() => {
              dispatch({
                type: "UPDATE_FOLDER_TREE",
                payload: 1,
              });
              dispatch({
                type: "RENAME_SCENARIO",
                payload: name,
              });
              dispatch({
                type: "SEND TO SERVER NEW PROPERTIES",
                payload: false,
              });
              dispatch({
                type: "IS_CHANGED_CURRENT_SCENARIO",
                payload: false,
              });
              dispatch({
                type: "GET SCENARIO PROPERTIES",
                payload: false,
              });
            })
            .then(() => {
              dispatch({
                type: "NEW_SCENARIO_SIMULATED_ID",
                payload: scenarioSimulateID,
              });
              dispatch({
                type: "NEW_TEMPLATE_SIMULATED_ID",
                payload: 0,
              });
              dispatch({
                type: "IS_NEED_REFRESH_SIMULATION",
                payload: true,
              });
              dispatch({
                type: "IS_CHANGED_CURRENT_SCENARIO",
                payload: false,
              });
              dispatch({
                type: "GET SCENARIO PROPERTIES",
                payload: false,
              });
            });

          if (response.status === 401) {
            navigate("/login");
          }
          const items = await response.json();
          resolveDTO(items);
        } catch (error) {
          setErrorMsg(error.message);
        }
      };
      updateProperty();
    }
  }, [isNeedSendToServerNewProperties]);

  // parse DTO
  const resolveDTO = (items) => {
    setName(items?.name);
    setDescription(items?.description);
    setBeginDate(items?.beginDate);
    setEndDate(items?.endDate);
    setInitialInventory(items?.initialInventory);

    setRuleType(items?.ruleType);

    setRuleFragment(items?.ruleFragmentDTO);
    setDdmrpRuleFragment(items?.ddmrpRuleFragmentDTO);
    setTocRuleFragment(items?.tocRuleFragmentDTO);
    setPenetrationTocRuleFragment(items?.penetrationTocRuleFragmentDTO);
    setPenetrationTocWithSmallTslRuleFragment(
      items?.penetrationTocWithSmallTslRuleFragmentDTO
    );
    setConsumptionTocRuleFragment(items?.consumptionTocRuleFragmentDTO);

    setOrderingFrequency(
      PropertyService.roundingDouble(items?.ruleFragmentDTO?.orderingFrequency)
    );
    setMinOrderQuantity(
      PropertyService.roundingDouble(items?.ruleFragmentDTO?.minOrderQuantity)
    );
    setOrderingQuantum(
      PropertyService.roundingDouble(items?.ruleFragmentDTO?.orderingQuantum)
    );

    setTslRedLevel(
      PropertyService.roundingDouble(items?.tocRuleFragmentDTO?.tslRedLevel)
    );
    setTslYellowLevel(
      PropertyService.roundingDouble(items?.tocRuleFragmentDTO?.tslYellowLevel)
    );
    setAbsoluteMinimumTSL(
      PropertyService.roundingDouble(
        items?.tocRuleFragmentDTO?.absoluteMinimumTSL
      )
    );
    setTslRoundingMultiple(
      PropertyService.roundingDouble(
        items?.tocRuleFragmentDTO?.tslRoundingMultiple
      )
    );
    setInitialTSLCalculationRuleType(
      items?.tocRuleFragmentDTO?.initialTSLCalculationRuleType
    );
    setInitialTSLCalculationAggregationType(
      items?.tocRuleFragmentDTO?.initialTSLCalculationAggregationType
    );
    setInitialTSLCalculationWindowSizeRRTs(
      PropertyService.roundingDouble(
        items?.tocRuleFragmentDTO?.initialTSLCalculationWindowSizeRRTs
      )
    );
    setIsUseHybridRule(items?.tocRuleFragmentDTO?.useHybridRule);
    setHybridAdjustmentHorizonRRTs(
      PropertyService.roundingDouble(
        items?.tocRuleFragmentDTO?.hybridAdjustmentHorizonRRTs
      )
    );
    setHybridIncreaseThreshold(
      PropertyService.roundingDouble(
        items?.tocRuleFragmentDTO?.hybridIncreaseThreshold
      )
    );
    setHybridDecreaseThreshold(
      PropertyService.roundingDouble(
        items?.tocRuleFragmentDTO?.hybridDecreaseThreshold
      )
    );

    setZoneQuantum(
      PropertyService.roundingDouble(items?.ddmrpRuleFragmentDTO?.zoneQuantum)
    );
    setRecalculationFrequency(
      PropertyService.roundingDouble(
        items?.ddmrpRuleFragmentDTO?.recalculationFrequency
      )
    );
    setConsiderationPeriod(
      PropertyService.roundingDouble(
        items?.ddmrpRuleFragmentDTO?.considerationPeriod
      )
    );
    setForwardConsideration(
      PropertyService.roundingDouble(
        items?.ddmrpRuleFragmentDTO?.forwardConsideration
      )
    );
    setVariabilityFactor(
      PropertyService.roundingDouble(
        items?.ddmrpRuleFragmentDTO?.variabilityFactor
      )
    );
    setRedZoneLeadTimeFactor(
      PropertyService.roundingDouble(
        items?.ddmrpRuleFragmentDTO?.redZoneLeadTimeFactor
      )
    );
    setGreenZoneLeadTimeFactor(
      PropertyService.roundingDouble(
        items?.ddmrpRuleFragmentDTO?.greenZoneLeadTimeFactor
      )
    );
    setIsConsiderPreOrders(items?.ddmrpRuleFragment?.ddmrpRuleFragmentDTO);
    setQualifiedSpikeHorizon(
      PropertyService.roundingDouble(
        items?.ddmrpRuleFragmentDTO?.qualifiedSpikeHorizon
      )
    );
    setQualifiedSpikeSizeFractionTopOfRed(
      PropertyService.roundingDouble(
        items?.ddmrpRuleFragmentDTO?.qualifiedSpikeSizeFractionTopOfRed
      )
    );
    setIsRecalculateDLT(items?.ddmrpRuleFragmentDTO?.recalculateDLT);
    setDltRecalculationHorizonDLTs(
      PropertyService.roundingDouble(
        items?.ddmrpRuleFragmentDTO?.dltRecalculationHorizonDLTs
      )
    );

    setTargetBufferIncreasePercent(
      PropertyService.roundingDouble(
        items?.penetrationTocRuleFragmentDTO?.targetBufferIncreasePercent
      )
    );
    setTargetBufferDecreasePercent(
      PropertyService.roundingDouble(
        items?.penetrationTocRuleFragmentDTO?.targetBufferDecreasePercent
      )
    );
    setRedSlidingWindowSizeInRRTs(
      PropertyService.roundingDouble(
        items?.penetrationTocRuleFragmentDTO?.redSlidingWindowSizeInRRTs
      )
    );
    setGreenSlidingWindowSizeInRRTs(
      PropertyService.roundingDouble(
        items?.penetrationTocRuleFragmentDTO?.greenSlidingWindowSizeInRRTs
      )
    );
    setRedToleranceTimeInRRTs(
      PropertyService.roundingDouble(
        items?.penetrationTocRuleFragmentDTO?.redToleranceTimeInRRTs
      )
    );
    setRedPenetrationThreshold(
      PropertyService.roundingDouble(
        items?.penetrationTocRuleFragmentDTO?.redPenetrationThreshold
      )
    );
    setRedPenetrationCountingCriteria(
      items?.penetrationTocRuleFragmentDTO?.redPenetrationCountingCriteria
    );

    setUseRedDaysBasedRuleForTSLBelow(
      PropertyService.roundingDouble(
        items?.penetrationTocWithSmallTslRuleFragmentDTO
          ?.useRedDaysBasedRuleForTSLBelow
      )
    );
    setRedDaysBackwardLookingHorizonRRTs(
      PropertyService.roundingDouble(
        items?.penetrationTocWithSmallTslRuleFragmentDTO
          ?.redDaysBackwardLookingHorizonRRTs
      )
    );
    setRedDaysNumberToIncreaseTSL(
      PropertyService.roundingDouble(
        items?.penetrationTocWithSmallTslRuleFragmentDTO
          ?.redDaysNumberToIncreaseTSL
      )
    );
    setGreenPeriodToDecreaseTSLRRTs(
      PropertyService.roundingDouble(
        items?.penetrationTocWithSmallTslRuleFragmentDTO
          ?.greenPeriodToDecreaseTSLRRTs
      )
    );
    setWaitingPeriodBeforeCheckingToIncreaseTSLRRTs(
      PropertyService.roundingDouble(
        items?.penetrationTocWithSmallTslRuleFragmentDTO
          ?.waitingPeriodBeforeCheckingToIncreaseTSLRRTs
      )
    );

    setConsumptionAggregationType(
      items?.consumptionTocRuleFragmentDTO?.consumptionAggregationType
    );
    setConsumptionTimeWindowRRTs(
      PropertyService.roundingDouble(
        items?.consumptionTocRuleFragmentDTO?.consumptionTimeWindowRRTs
      )
    );
  };

  // power ON / OFF red star (edition mode)
  const showRedStarEditionMode = (flag) => {
    dispatch({
      type: "IS_CHANGED_CURRENT_SCENARIO",
      payload: flag,
    });
  };

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (isChangedCurrentScenario) {
      return;
    }
    dispatch({
      type: "IS_CHANGED_CURRENT_SCENARIO",
      payload: true,
    });
  }, [
    name,
    beginDate,
    endDate,
    description,
    initialInventory,
    orderingFrequency,
    minOrderQuantity,
    orderingQuantum,
    tslRedLevel,
    tslYellowLevel,
    absoluteMinimumTSL,
    tslRoundingMultiple,
    initialTSLCalculationRuleType,
    initialTSLCalculationAggregationType,
    initialTSLCalculationAggregationType,
    initialTSLCalculationWindowSizeRRTs,
    initialTSLCalculationWindowSizeRRTs,
    isUseHybridRule,
    hybridAdjustmentHorizonRRTs,
    hybridIncreaseThreshold,
    hybridDecreaseThreshold,
    zoneQuantum,
    recalculationFrequency,
    considerationPeriod,
    forwardConsideration,
    variabilityFactor,
    redZoneLeadTimeFactor,
    greenZoneLeadTimeFactor,
    isConsiderPreOrders,
    qualifiedSpikeHorizon,
    qualifiedSpikeSizeFractionTopOfRed,
    isRecalculateDLT,
    dltRecalculationHorizonDLTs,
    targetBufferIncreasePercent,
    targetBufferDecreasePercent,
    redSlidingWindowSizeInRRTs,
    greenSlidingWindowSizeInRRTs,
    redToleranceTimeInRRTs,
    redPenetrationThreshold,
    redPenetrationCountingCriteria,
    useRedDaysBasedRuleForTSLBelow,
    redDaysBackwardLookingHorizonRRTs,
    redDaysNumberToIncreaseTSL,
    greenPeriodToDecreaseTSLRRTs,
    waitingPeriodBeforeCheckingToIncreaseTSLRRTs,
    waitingPeriodBeforeCheckingToIncreaseTSLRRTs,
    consumptionAggregationType,
    consumptionTimeWindowRRTs,
  ]);

  // handler enum values
  const handleEnumValues = (event) => {
    const id = event.target.id;
    const value = event.target.value;

    if (id === "initialTSLCalculationRuleType") {
      setInitialTSLCalculationRuleType(value);
    }

    if (id === "initialTSLCalculationAggregationType") {
      setInitialTSLCalculationAggregationType(value);
    }

    if (id === "consumptionAggregationType") {
      setConsumptionAggregationType(value);
    }

    if (id === "redPenetrationCountingCriteria") {
      setRedPenetrationCountingCriteria(value);
    }
  };

  // validate input dates
  useEffect(() => {
    if (beginDate > endDate) {
      setDateError("Begin date is later than end date");
    } else {
      setDateError();
    }
  }, [beginDate, endDate]);

  // handle begin date
  const handleTextAndDateFields = (event) => {
    const id = event.target.id;
    const value = event.target.value;

    if (id === "beginDate") {
      setBeginDate(value);
    }
    if (id === "endDate") {
      setEndDate(value);
    }
    if (id === "name") {
      if (value.length === 0) {
        setNameError("Name field  must be filled");
      } else {
        setNameError();
      }
      setName(value);
    }
    if (id === "description") {
      setDescription(value);
    }
  };

  const roundAllProperties = () => {
    setOrderingFrequency(
      PropertyService.roundProperty(
        orderingFrequency,
        1,
        PROPERTY_LIMITATIONS.ORDERING_FREQUENCY_SCALE
      )
    );
    setMinOrderQuantity(
      PropertyService.roundProperty(
        minOrderQuantity,
        1,
        PROPERTY_LIMITATIONS.MIN_ORDER_QUANTITY_SCALE
      )
    );
    setOrderingQuantum(
      PropertyService.roundProperty(
        orderingQuantum,
        1,
        PROPERTY_LIMITATIONS.ORDERING_QUANTUM_SCALE
      )
    );
    setTslRedLevel(
      PropertyService.roundProperty(
        tslRedLevel,
        100,
        PROPERTY_LIMITATIONS.TSL_RED_LEVEL_SCALE
      )
    );
    setTslYellowLevel(
      PropertyService.roundProperty(
        tslYellowLevel,
        100,
        PROPERTY_LIMITATIONS.TSL_YELLOW_LEVEL_SCALE
      )
    );
    setAbsoluteMinimumTSL(
      PropertyService.roundProperty(
        absoluteMinimumTSL,
        1,
        PROPERTY_LIMITATIONS.ABSOLUTE_MINIMUM_TSL_SCALE
      )
    );
    setTslRoundingMultiple(
      PropertyService.roundProperty(
        tslRoundingMultiple,
        1,
        PROPERTY_LIMITATIONS.TSL_ROUNDING_MULTIPLE_SCALE
      )
    );
    setInitialTSLCalculationWindowSizeRRTs(
      PropertyService.roundProperty(
        initialTSLCalculationWindowSizeRRTs,
        10,
        PROPERTY_LIMITATIONS.INITIAL_TSL_CALCULATION_WINDOW_SIZE_RRTS_SCALE
      )
    );
    setHybridAdjustmentHorizonRRTs(
      PropertyService.roundProperty(
        hybridAdjustmentHorizonRRTs,
        10,
        PROPERTY_LIMITATIONS.HYBRID_ADJUSTMENT_HORIZON_RRTS_SCALE
      )
    );
    setHybridIncreaseThreshold(
      PropertyService.roundProperty(
        hybridIncreaseThreshold,
        10,
        PROPERTY_LIMITATIONS.HYBRID_INCREASE_THRESHOLD_SCALE
      )
    );
    setHybridDecreaseThreshold(
      PropertyService.roundProperty(
        hybridDecreaseThreshold,
        10,
        PROPERTY_LIMITATIONS.HYBRID_DECREASE_THRESHOLD_SCALE
      )
    );
    setZoneQuantum(
      PropertyService.roundProperty(
        zoneQuantum,
        1,
        PROPERTY_LIMITATIONS.ZONE_QUANTUM_SCALE
      )
    );
    setRecalculationFrequency(
      PropertyService.roundProperty(
        recalculationFrequency,
        1,
        PROPERTY_LIMITATIONS.RECALCULATION_FREQUENCY_SCALE
      )
    );
    setConsiderationPeriod(
      PropertyService.roundProperty(
        considerationPeriod,
        10,
        PROPERTY_LIMITATIONS.CONSIDERATION_PERIOD_SCALE
      )
    );
    setForwardConsideration(
      PropertyService.roundProperty(
        forwardConsideration,
        10,
        PROPERTY_LIMITATIONS.FORWARD_CONSIDERATION_SCALE
      )
    );
    setVariabilityFactor(
      PropertyService.roundProperty(
        variabilityFactor,
        10,
        PROPERTY_LIMITATIONS.VARIABILITY_FACTOR_SCALE
      )
    );
    setRedZoneLeadTimeFactor(
      PropertyService.roundProperty(
        redZoneLeadTimeFactor,
        10,
        PROPERTY_LIMITATIONS.RED_ZONE_LEAD_TIME_FACTOR_SCALE
      )
    );
    setGreenZoneLeadTimeFactor(
      PropertyService.roundProperty(
        greenZoneLeadTimeFactor,
        10,
        PROPERTY_LIMITATIONS.GREEN_ZONE_LEAD_TIME_FACTOR_SCALE
      )
    );
    setQualifiedSpikeHorizon(
      PropertyService.roundProperty(
        qualifiedSpikeHorizon,
        1,
        PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_HORIZON_SCALE
      )
    );
    setQualifiedSpikeSizeFractionTopOfRed(
      PropertyService.roundProperty(
        qualifiedSpikeSizeFractionTopOfRed,
        100,
        PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_SIZE_FRACTION_TOP_OF_RED_SCALE
      )
    );
    setDltRecalculationHorizonDLTs(
      PropertyService.roundProperty(
        dltRecalculationHorizonDLTs,
        10,
        PROPERTY_LIMITATIONS.DLT_RECALCULATION_HORIZON_DLTS_SCALE
      )
    );
    setTargetBufferIncreasePercent(
      PropertyService.roundProperty(
        targetBufferIncreasePercent,
        10,
        PROPERTY_LIMITATIONS.TARGET_BUFFER_INCREASE_PERCENT_SCALE
      )
    );
    setTargetBufferDecreasePercent(
      PropertyService.roundProperty(
        targetBufferDecreasePercent,
        10,
        PROPERTY_LIMITATIONS.TARGET_BUFFER_DECREASE_PERCENT_SCALE
      )
    );
    setRedSlidingWindowSizeInRRTs(
      PropertyService.roundProperty(
        redSlidingWindowSizeInRRTs,
        10,
        PROPERTY_LIMITATIONS.RED_SLIDING_WINDOW_SIZE_IN_RRTS_SCALE
      )
    );
    setGreenSlidingWindowSizeInRRTs(
      PropertyService.roundProperty(
        greenSlidingWindowSizeInRRTs,
        10,
        PROPERTY_LIMITATIONS.GREEN_SLIDING_WINDOW_SIZE_IN_RRTS_SCALE
      )
    );
    setRedToleranceTimeInRRTs(
      PropertyService.roundProperty(
        redToleranceTimeInRRTs,
        10,
        PROPERTY_LIMITATIONS.RED_TOLERANCE_TIME_IN_RRTS_SCALE
      )
    );
    setRedPenetrationThreshold(
      PropertyService.roundProperty(
        redPenetrationThreshold,
        20,
        PROPERTY_LIMITATIONS.RED_PENETRATION_THRESHOLD_SCALE
      )
    );
    setUseRedDaysBasedRuleForTSLBelow(
      PropertyService.roundProperty(
        useRedDaysBasedRuleForTSLBelow,
        1,
        PROPERTY_LIMITATIONS.USE_RED_DAYS_BASED_RULE_FOR_TSL_BELOW_SCALE
      )
    );
    setRedDaysBackwardLookingHorizonRRTs(
      PropertyService.roundProperty(
        redDaysBackwardLookingHorizonRRTs,
        10,
        PROPERTY_LIMITATIONS.RED_DAYS_BACKWARD_LOOKING_HORIZON_RRTS_SCALE
      )
    );
    setRedDaysNumberToIncreaseTSL(
      PropertyService.roundProperty(
        redDaysNumberToIncreaseTSL,
        1,
        PROPERTY_LIMITATIONS.RED_DAYS_NUMBER_TO_INCREASE_TSL_SCALE
      )
    );
    setGreenPeriodToDecreaseTSLRRTs(
      PropertyService.roundProperty(
        greenPeriodToDecreaseTSLRRTs,
        10,
        PROPERTY_LIMITATIONS.GREEN_PERIOD_TO_DECREASE_TSLRRTS_SCALE
      )
    );
    setWaitingPeriodBeforeCheckingToIncreaseTSLRRTs(
      PropertyService.roundProperty(
        waitingPeriodBeforeCheckingToIncreaseTSLRRTs,
        10,
        PROPERTY_LIMITATIONS.WAITING_PERIOD_BEFORE_CHECKING_TO_INCREASE_TSLRRTS_SCALE
      )
    );
    setConsumptionTimeWindowRRTs(
      PropertyService.roundProperty(
        consumptionTimeWindowRRTs,
        10,
        PROPERTY_LIMITATIONS.CONSUMPTION_TIME_WINDOW_RRTS_SCALE
      )
    );
  };

  // concat error message
  const getErrorMessage = (min, max, scale) => {
    return `Input a number between ${min} and ${max} (${scale} decimal digits)`;
  };

  // handler doubles inputs
  const handleDoubleValue = (event) => {
    const id = event.target.id;
    const value = event.target.value;

    if (id === "initialInventory") {
      setInitialInventory(value);
      if (PropertyService.isValidValue(value, id)) {
        setInitialInventoryError();
      } else {
        setInitialInventoryError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.INITIAL_INVENTORY_MIN,
            PROPERTY_LIMITATIONS.INITIAL_INVENTORY_MAX,
            PROPERTY_LIMITATIONS.INITIAL_INVENTORY_SCALE
          )
        );
      }
    }

    if (id === "orderingFrequency") {
      setOrderingFrequency(value);
      if (PropertyService.isValidValue(value, id)) {
        setOrderingFrequencyError();
      } else {
        setOrderingFrequencyError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.ORDERING_FREQUENCY_MIN,
            PROPERTY_LIMITATIONS.ORDERING_FREQUENCY_MAX,
            PROPERTY_LIMITATIONS.ORDERING_FREQUENCY_SCALE
          )
        );
      }
    }

    if (id === "minOrderQuantity") {
      setMinOrderQuantity(value);
      if (PropertyService.isValidValue(value, id)) {
        setMinOrderQuantityError();
      } else {
        setMinOrderQuantityError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.MIN_ORDER_QUANTITY_MIN,
            PROPERTY_LIMITATIONS.MIN_ORDER_QUANTITY_MAX,
            PROPERTY_LIMITATIONS.MIN_ORDER_QUANTITY_SCALE
          )
        );
      }
    }

    if (id === "orderingQuantum") {
      setOrderingQuantum(value);
      if (PropertyService.isValidValue(value, id)) {
        setOrderingQuantumError();
      } else {
        setOrderingQuantumError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.ORDERING_QUANTUM_MIN,
            PROPERTY_LIMITATIONS.ORDERING_QUANTUM_MAX,
            PROPERTY_LIMITATIONS.ORDERING_QUANTUM_SCALE
          )
        );
      }
    }

    if (id === "tslRedLevel") {
      setTslRedLevel(value);
      if (PropertyService.isValidValue(value, id)) {
        if (value > tslYellowLevel) {
          setTslRedLevelError(
            "'TSL Red Level' must be less than 'TSL Yellow Level'"
          );
        } else {
          setTslRedLevelError();
        }
      } else {
        setTslRedLevelError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.TSL_RED_LEVEL_MIN,
            PROPERTY_LIMITATIONS.TSL_RED_LEVEL_MAX,
            PROPERTY_LIMITATIONS.TSL_RED_LEVEL_SCALE
          )
        );
      }
    }

    if (id === "tslYellowLevel") {
      setTslYellowLevel(value);
      if (PropertyService.isValidValue(value, id)) {
        if (value < tslRedLevel) {
          setTslYellowLevelError(
            "'TSL Yellow Level' must be greater than 'TSL Red Level'"
          );
        } else {
          setTslYellowLevelError();
        }
      } else {
        setTslYellowLevelError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.TSL_YELLOW_LEVEL_MIN,
            PROPERTY_LIMITATIONS.TSL_YELLOW_LEVEL_MAX,
            PROPERTY_LIMITATIONS.TSL_YELLOW_LEVEL_SCALE
          )
        );
      }
    }

    if (id === "absoluteMinimumTSL") {
      setAbsoluteMinimumTSL(value);
      if (PropertyService.isValidValue(value, id)) {
        setAbsoluteMinimumTSLError();
      } else {
        setAbsoluteMinimumTSLError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.ABSOLUTE_MINIMUM_TSL_MIN,
            PROPERTY_LIMITATIONS.ABSOLUTE_MINIMUM_TSL_MAX,
            PROPERTY_LIMITATIONS.ABSOLUTE_MINIMUM_TSL_SCALE
          )
        );
      }
    }

    if (id === "tslRoundingMultiple") {
      setTslRoundingMultiple(value);
      if (PropertyService.isValidValue(value, id)) {
        setTslRoundingMultipleError();
      } else {
        setTslRoundingMultipleError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.TSL_ROUNDING_MULTIPLE_MIN,
            PROPERTY_LIMITATIONS.TSL_ROUNDING_MULTIPLE_MAX,
            PROPERTY_LIMITATIONS.TSL_ROUNDING_MULTIPLE_SCALE
          )
        );
      }
    }

    if (id === "initialTSLCalculationWindowSizeRRTs") {
      setInitialTSLCalculationWindowSizeRRTs(value);
      if (PropertyService.isValidValue(value, id)) {
        setInitialTSLCalculationWindowSizeRRTsError();
      } else {
        setInitialTSLCalculationWindowSizeRRTsError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.INITIAL_TSL_CALCULATION_WINDOW_SIZE_RRTS_MIN,
            PROPERTY_LIMITATIONS.INITIAL_TSL_CALCULATION_WINDOW_SIZE_RRTS_MAX,
            PROPERTY_LIMITATIONS.INITIAL_TSL_CALCULATION_WINDOW_SIZE_RRTS_SCALE
          )
        );
      }
    }

    if (id === "hybridAdjustmentHorizonRRTs") {
      setHybridAdjustmentHorizonRRTs(value);
      if (PropertyService.isValidValue(value, id)) {
        setHybridAdjustmentHorizonRRTsError();
      } else {
        setHybridAdjustmentHorizonRRTsError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.HYBRID_ADJUSTMENT_HORIZON_RRTS_MIN,
            PROPERTY_LIMITATIONS.HYBRID_ADJUSTMENT_HORIZON_RRTS_MAX,
            PROPERTY_LIMITATIONS.HYBRID_ADJUSTMENT_HORIZON_RRTS_SCALE
          )
        );
      }
    }

    if (id === "hybridIncreaseThreshold") {
      setHybridIncreaseThreshold(value);
      if (PropertyService.isValidValue(value, id)) {
        setHybridIncreaseThresholdError();
      } else {
        setHybridIncreaseThresholdError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.HYBRID_INCREASE_THRESHOLD_MIN,
            PROPERTY_LIMITATIONS.HYBRID_INCREASE_THRESHOLD_MAX,
            PROPERTY_LIMITATIONS.HYBRID_INCREASE_THRESHOLD_SCALE
          )
        );
      }
    }

    if (id === "hybridDecreaseThreshold") {
      setHybridDecreaseThreshold(value);
      if (PropertyService.isValidValue(value, id)) {
        setHybridDecreaseThresholdError();
      } else {
        setHybridDecreaseThresholdError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.HYBRID_DECREASE_THRESHOLD_MIN,
            PROPERTY_LIMITATIONS.HYBRID_DECREASE_THRESHOLD_MAX,
            PROPERTY_LIMITATIONS.HYBRID_DECREASE_THRESHOLD_SCALE
          )
        );
      }
    }

    if (id === "targetBufferIncreasePercent") {
      setTargetBufferIncreasePercent(value);
      if (PropertyService.isValidValue(value, id)) {
        setTargetBufferIncreasePercentError();
      } else {
        setTargetBufferIncreasePercentError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.TARGET_BUFFER_INCREASE_PERCENT_MIN,
            PROPERTY_LIMITATIONS.TARGET_BUFFER_INCREASE_PERCENT_MAX,
            PROPERTY_LIMITATIONS.TARGET_BUFFER_INCREASE_PERCENT_SCALE
          )
        );
      }
    }

    if (id === "targetBufferDecreasePercent") {
      setTargetBufferDecreasePercent(value);
      if (PropertyService.isValidValue(value, id)) {
        setTargetBufferDecreasePercentError();
      } else {
        setTargetBufferDecreasePercentError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.TARGET_BUFFER_DECREASE_PERCENT_MIN,
            PROPERTY_LIMITATIONS.TARGET_BUFFER_DECREASE_PERCENT_MAX,
            PROPERTY_LIMITATIONS.TARGET_BUFFER_DECREASE_PERCENT_SCALE
          )
        );
      }
    }

    if (id === "redSlidingWindowSizeInRRTs") {
      setRedSlidingWindowSizeInRRTs(value);
      if (PropertyService.isValidValue(value, id)) {
        setRedSlidingWindowSizeInRRTsError();
      } else {
        setRedSlidingWindowSizeInRRTsError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.RED_SLIDING_WINDOW_SIZE_IN_RRTS_MIN,
            PROPERTY_LIMITATIONS.RED_SLIDING_WINDOW_SIZE_IN_RRTS_MAX,
            PROPERTY_LIMITATIONS.RED_SLIDING_WINDOW_SIZE_IN_RRTS_SCALE
          )
        );
      }
    }

    if (id === "greenSlidingWindowSizeInRRTs") {
      setGreenSlidingWindowSizeInRRTs(value);
      if (PropertyService.isValidValue(value, id)) {
        setGreenSlidingWindowSizeInRRTsError();
      } else {
        setGreenSlidingWindowSizeInRRTsError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.GREEN_SLIDING_WINDOW_SIZE_IN_RRTS_MIN,
            PROPERTY_LIMITATIONS.GREEN_SLIDING_WINDOW_SIZE_IN_RRTS_MAX,
            PROPERTY_LIMITATIONS.GREEN_SLIDING_WINDOW_SIZE_IN_RRTS_SCALE
          )
        );
      }
    }

    if (id === "redToleranceTimeInRRTs") {
      setRedToleranceTimeInRRTs(value);
      if (PropertyService.isValidValue(value, id)) {
        setRedToleranceTimeInRRTsError();
      } else {
        setRedToleranceTimeInRRTsError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.RED_TOLERANCE_TIME_IN_RRTS_MIN,
            PROPERTY_LIMITATIONS.RED_TOLERANCE_TIME_IN_RRTS_MAX,
            PROPERTY_LIMITATIONS.RED_TOLERANCE_TIME_IN_RRTS_SCALE
          )
        );
      }
    }

    if (id === "redPenetrationThreshold") {
      setRedPenetrationThreshold(value);
      if (PropertyService.isValidValue(value, id)) {
        setRedPenetrationThresholdError();
      } else {
        setRedPenetrationThresholdError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.RED_PENETRATION_THRESHOLD_MIN,
            PROPERTY_LIMITATIONS.RED_PENETRATION_THRESHOLD_MAX,
            PROPERTY_LIMITATIONS.RED_PENETRATION_THRESHOLD_SCALE
          )
        );
      }
    }

    if (id === "useRedDaysBasedRuleForTSLBelow") {
      setUseRedDaysBasedRuleForTSLBelow(value);
      if (PropertyService.isValidValue(value, id)) {
        setUseRedDaysBasedRuleForTSLBelowError();
      } else {
        setUseRedDaysBasedRuleForTSLBelowError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.USE_RED_DAYS_BASED_RULE_FOR_TSL_BELOW_MIN,
            PROPERTY_LIMITATIONS.USE_RED_DAYS_BASED_RULE_FOR_TSL_BELOW_MAX,
            PROPERTY_LIMITATIONS.USE_RED_DAYS_BASED_RULE_FOR_TSL_BELOW_SCALE
          )
        );
      }
    }

    if (id === "redDaysBackwardLookingHorizonRRTs") {
      setRedDaysBackwardLookingHorizonRRTs(value);
      if (PropertyService.isValidValue(value, id)) {
        setRedDaysBackwardLookingHorizonRRTsError();
      } else {
        setRedDaysBackwardLookingHorizonRRTsError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.RED_DAYS_BACKWARD_LOOKING_HORIZON_RRTS_MIN,
            PROPERTY_LIMITATIONS.RED_DAYS_BACKWARD_LOOKING_HORIZON_RRTS_MAX,
            PROPERTY_LIMITATIONS.RED_DAYS_BACKWARD_LOOKING_HORIZON_RRTS_SCALE
          )
        );
      }
    }

    if (id === "redDaysNumberToIncreaseTSL") {
      setRedDaysNumberToIncreaseTSL(value);
      if (PropertyService.isValidValue(value, id)) {
        setRedDaysNumberToIncreaseTSLError();
      } else {
        setRedDaysNumberToIncreaseTSLError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.RED_DAYS_NUMBER_TO_INCREASE_TSL_MIN,
            PROPERTY_LIMITATIONS.RED_DAYS_NUMBER_TO_INCREASE_TSL_MAX,
            PROPERTY_LIMITATIONS.RED_DAYS_NUMBER_TO_INCREASE_TSL_SCALE
          )
        );
      }
    }

    if (id === "greenPeriodToDecreaseTSLRRTs") {
      setGreenPeriodToDecreaseTSLRRTs(value);
      if (PropertyService.isValidValue(value, id)) {
        setGreenPeriodToDecreaseTSLRRTsError();
      } else {
        setGreenPeriodToDecreaseTSLRRTsError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.GREEN_PERIOD_TO_DECREASE_TSLRRTS_MIN,
            PROPERTY_LIMITATIONS.GREEN_PERIOD_TO_DECREASE_TSLRRTS_MAX,
            PROPERTY_LIMITATIONS.GREEN_PERIOD_TO_DECREASE_TSLRRTS_SCALE
          )
        );
      }
    }

    if (id === "waitingPeriodBeforeCheckingToIncreaseTSLRRTs") {
      setWaitingPeriodBeforeCheckingToIncreaseTSLRRTs(value);
      if (PropertyService.isValidValue(value, id)) {
        setWaitingPeriodBeforeCheckingToIncreaseTSLRRTsError();
      } else {
        setWaitingPeriodBeforeCheckingToIncreaseTSLRRTsError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.WAITING_PERIOD_BEFORE_CHECKING_TO_INCREASE_TSLRRTS_MIN,
            PROPERTY_LIMITATIONS.WAITING_PERIOD_BEFORE_CHECKING_TO_INCREASE_TSLRRTS_MAX,
            PROPERTY_LIMITATIONS.WAITING_PERIOD_BEFORE_CHECKING_TO_INCREASE_TSLRRTS_SCALE
          )
        );
      }
    }

    if (id === "consumptionTimeWindowRRTs") {
      setConsumptionTimeWindowRRTs(value);
      if (PropertyService.isValidValue(value, id)) {
        setConsumptionTimeWindowRRTsError();
      } else {
        setConsumptionTimeWindowRRTsError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.CONSUMPTION_TIME_WINDOW_RRTS_MIN,
            PROPERTY_LIMITATIONS.CONSUMPTION_TIME_WINDOW_RRTS_MAX,
            PROPERTY_LIMITATIONS.CONSUMPTION_TIME_WINDOW_RRTS_SCALE
          )
        );
      }
    }

    if (id === "zoneQuantum") {
      setZoneQuantum(value);
      if (PropertyService.isValidValue(value, id)) {
        setZoneQuantumError();
      } else {
        setZoneQuantumError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.ZONE_QUANTUM_MIN,
            PROPERTY_LIMITATIONS.ZONE_QUANTUM_MAX,
            PROPERTY_LIMITATIONS.ZONE_QUANTUM_SCALE
          )
        );
      }
    }

    if (id === "recalculationFrequency") {
      setRecalculationFrequency(value);
      if (PropertyService.isValidValue(value, id)) {
        setRecalculationFrequencyError();
      } else {
        setRecalculationFrequencyError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.RECALCULATION_FREQUENCY_MIN,
            PROPERTY_LIMITATIONS.RECALCULATION_FREQUENCY_MAX,
            PROPERTY_LIMITATIONS.RECALCULATION_FREQUENCY_SCALE
          )
        );
      }
    }

    if (id === "considerationPeriod") {
      setConsiderationPeriod(value);
      if (PropertyService.isValidValue(value, id)) {
        setConsiderationPeriodError();
      } else {
        setConsiderationPeriodError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.CONSIDERATION_PERIOD_MIN,
            PROPERTY_LIMITATIONS.CONSIDERATION_PERIOD_MAX,
            PROPERTY_LIMITATIONS.CONSIDERATION_PERIOD_SCALE
          )
        );
      }
    }

    if (id === "forwardConsideration") {
      setForwardConsideration(value);
      if (PropertyService.isValidValue(value, id)) {
        setForwardConsiderationError();
      } else {
        setForwardConsiderationError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.FORWARD_CONSIDERATION_MIN,
            PROPERTY_LIMITATIONS.FORWARD_CONSIDERATION_MAX,
            PROPERTY_LIMITATIONS.FORWARD_CONSIDERATION_SCALE
          )
        );
      }
    }

    if (id === "variabilityFactor") {
      setVariabilityFactor(value);
      if (PropertyService.isValidValue(value, id)) {
        setVariabilityFactorError();
      } else {
        setVariabilityFactorError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.VARIABILITY_FACTOR_MIN,
            PROPERTY_LIMITATIONS.VARIABILITY_FACTOR_MAX,
            PROPERTY_LIMITATIONS.VARIABILITY_FACTOR_SCALE
          )
        );
      }
    }

    if (id === "redZoneLeadTimeFactor") {
      setRedZoneLeadTimeFactor(value);
      if (PropertyService.isValidValue(value, id)) {
        setRedZoneLeadTimeFactorError();
      } else {
        setRedZoneLeadTimeFactorError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.RED_ZONE_LEAD_TIME_FACTOR_MIN,
            PROPERTY_LIMITATIONS.RED_ZONE_LEAD_TIME_FACTOR_MAX,
            PROPERTY_LIMITATIONS.RED_ZONE_LEAD_TIME_FACTOR_SCALE
          )
        );
      }
    }

    if (id === "greenZoneLeadTimeFactor") {
      setGreenZoneLeadTimeFactor(value);
      if (PropertyService.isValidValue(value, id)) {
        setGreenZoneLeadTimeFactorError();
      } else {
        setGreenZoneLeadTimeFactorError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.GREEN_ZONE_LEAD_TIME_FACTOR_MIN,
            PROPERTY_LIMITATIONS.GREEN_ZONE_LEAD_TIME_FACTOR_MAX,
            PROPERTY_LIMITATIONS.GREEN_ZONE_LEAD_TIME_FACTOR_SCALE
          )
        );
      }
    }

    if (id === "qualifiedSpikeHorizon") {
      setQualifiedSpikeHorizon(value);
      if (PropertyService.isValidValue(value, id)) {
        setQualifiedSpikeHorizonError();
      } else {
        setQualifiedSpikeHorizonError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_HORIZON_MIN,
            PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_HORIZON_MAX,
            PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_HORIZON_SCALE
          )
        );
      }
    }

    if (id === "qualifiedSpikeSizeFractionTopOfRed") {
      setQualifiedSpikeSizeFractionTopOfRed(value);
      if (PropertyService.isValidValue(value, id)) {
        setQualifiedSpikeSizeFractionTopOfRedError();
      } else {
        setQualifiedSpikeSizeFractionTopOfRedError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_SIZE_FRACTION_TOP_OF_RED_MIN,
            PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_SIZE_FRACTION_TOP_OF_RED_MAX,
            PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_SIZE_FRACTION_TOP_OF_RED_SCALE
          )
        );
      }
    }

    if (id === "dltRecalculationHorizonDLTs") {
      setDltRecalculationHorizonDLTs(value);
      if (
        PropertyService.PropertyService.PropertyService.isValidValue(value, id)
      ) {
        setDltRecalculationHorizonDLTsError();
      } else {
        setDltRecalculationHorizonDLTsError(
          getErrorMessage(
            PROPERTY_LIMITATIONS.DLT_RECALCULATION_HORIZON_DLTS_MIN,
            PROPERTY_LIMITATIONS.DLT_RECALCULATION_HORIZON_DLTS_MAX,
            PROPERTY_LIMITATIONS.DLT_RECALCULATION_HORIZON_DLTS_SCALE
          )
        );
      }
    }
  };

  // handler checks inputs
  const handleCheckValue = (event) => {
    const id = event.target.id;
    const value = event.currentTarget.checked;

    if (id === "isConsiderPreOrders") {
      if (value === true) {
        setIsConsiderPreOrders(true);
      } else {
        setIsConsiderPreOrders(false);
      }
    }

    if (id === "isRecalculateDLT") {
      if (value === true) {
        setIsRecalculateDLT(true);
      } else {
        setIsRecalculateDLT(false);
      }
    }

    if (id === "isUseHybridRule") {
      if (value === true) {
        setIsUseHybridRule(true);
      } else {
        setIsUseHybridRule(false);
      }
    }
  };

  const simulate = (event) => {
    event.preventDefault();
    const ID = scenarioSimulateID;
    if (isTemplateCurrentScenario) {
      dispatch({
        type: "NEW_TEMPLATE_SIMULATED_ID",
        payload: ID,
      });
      dispatch({
        type: "NEW_SCENARIO_SIMULATED_ID",
        payload: 0,
      });
    } else {
      dispatch({
        type: "NEW_SCENARIO_SIMULATED_ID",
        payload: ID,
      });
      dispatch({
        type: "NEW_TEMPLATE_SIMULATED_ID",
        payload: 0,
      });
    }
    dispatch({
      type: "IS_NEED_REFRESH_SIMULATION",
      payload: true,
    });
  };

  // set new begin date
  const defineBeginDate = (command) => {
    const date = new Date();
    if (command === "today") {
      setBeginDate(PropertyService.sliceDate(date, 10));
    }
    if (command === "thisMonth") {
      setBeginDate(PropertyService.sliceDate(date, 8) + "01");
    }
  };

  // set new end date
  const defineEndDate = (command) => {
    const date = new Date(beginDate);
    if (command === "1W") {
      date.setDate(date.getDate() + 7);
      setEndDate(PropertyService.sliceDate(date, 10));
    }
    if (command === "1M") {
      date.setMonth(date.getMonth() + 1);
      setEndDate(PropertyService.sliceDate(date, 10));
    }
    if (command === "1Y") {
      date.setFullYear(date.getFullYear() + 1);
      setEndDate(PropertyService.sliceDate(date, 10));
    }
  };

  // parse demand forecast plot DTO
  const resolve = (values) => {
    const days = values?.days;
    const demand =
      values?.demand === undefined ? demandForecast.demand : values?.demand;

    // в случае если forecast удалён, заменяем его на undefined, чтобы старые данные не отображались
    const forecast =
      values?.forecast === undefined
        ? demandForecast.forecast
        : isNeedNoForecastRequest
        ? undefined
        : values?.forecast;

    return {
      days: days,
      demand: demand,
      forecast: forecast,
    };
  };

  // sum function
  const getTotalDemand = (data) => {
    const sum = data.reduce((a, b) => a + b);
    return sum;
  };

  // concat total demand string
  useEffect(() => {
    if (!beginDate || !endDate || !totalDemand) {
      return;
    } else {
      const begin = new Date(beginDate);
      const end = new Date(endDate);

      const difference = end.getTime() - begin.getTime();

      const dayMilliseconds = 1000 * 60 * 60 * 24;
      const dayDifference = difference / dayMilliseconds;
      const demandString = totalDemand === 1 ? "unit" : "units";
      const dayString = dayDifference === 1 ? "day" : "days";
      setDays(dayDifference);
      setTotalDemandString(
        `${totalDemand} ${demandString} / ${dayDifference} ${dayString}`
      );
    }
    return () => {};
  }, [
    beginDate,
    endDate,
    props.simulatedId,
    isNeedGetScenarioProperties,
    totalDemand,
    isNeedSendToServerNewProperties,
  ]);

  // get demand/forecast PLOT from server
  useEffect(() => {
    if (
      (scenarioSimulateID > 0 || templateSimulateID > 0) &&
      isNeedUpdateDemandForecastPlot
    ) {
      const fetchProps = async () => {
        try {
          const simId =
            scenarioSimulateID > 0 ? scenarioSimulateID : templateSimulateID;
          const response = await fetch(
            SCENARIOS_URL + simId + DEMAND_FORECAST_POSTFIX,
            {
              method: "GET",
              headers: headerService(),
            }
          );
          if (response.status === 401) {
            navigate("/login");
          }
          const items = await response.json();
          setDemandForecast(resolve(items));
          setMaxDemandForecastValue(findDemandForecastMaxValue(items));
          setTotalDemand(getTotalDemand(items?.demand));
        } catch (error) {
          setErrorMsg(error.message);
        }
      };
      fetchProps();
      setIsNeedNoForecastRequest(false);
      setIsNeedUpdateDemandForecastPlot(false);
    }
  }, [isNeedUpdateDemandForecastPlot]);

  // download CSV
  const downloadCSV = (data) => {
    const csvFile = `data:text/csv;charset=utf-8,${data}`;
    const encodedURI = encodeURI(csvFile);
    window.open(encodedURI);
  };

  // create CSV and download it
  const createCSV = (days, values, type) => {
    const daysAndValues = [];

    for (let index = 0; index < days.length; index++) {
      if (index === 0) {
        daysAndValues.push(`date,${type}\n`);
      }
      const date = new Date(days[index]);
      const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const correctedMonth = month > 9 ? month : `0${month}`;

      daysAndValues.push(`${day}.${correctedMonth}.${year},${values[index]}\n`);
    }
    const data = daysAndValues.join("");
    return data;
  };

  // download demand file
  const handleDownloadDemandFile = async (event) => {
    event.preventDefault();

    // if generated mode
    if (isDemandGenerateMode) {
      const data = createCSV(
        demandForecast?.days,
        demandForecast?.demand,
        "demand"
      );
      downloadCSV(data);
    } else {
      const downloadURL =
        SCENARIOS_URL + scenarioSimulateID + DEMAND_POSTFIX + FILE_POSTFIX;
      axios({
        url: downloadURL,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: BEARER,
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${name} demand.csv`);
        document.body.appendChild(link);
        link.click();
      });
    }
  };

  // download forecast file
  const handleDownloadForecastFile = async (event) => {
    event.preventDefault();

    // if generated mode
    if (isForecastGenerateMode) {
      const data = createCSV(
        demandForecast?.days,
        demandForecast?.forecast,
        "forecast"
      );
      downloadCSV(data);
    } else {
      const downloadURL =
        SCENARIOS_URL + scenarioSimulateID + FORECAST_POSTFIX + FILE_POSTFIX;
      axios({
        url: downloadURL,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: BEARER,
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${name} forecast.csv`);
        document.body.appendChild(link);
        link.click();
      });
    }
  };

  // choose file for upload
  function handleChooseFile(event) {
    setFile(event.target.files[0]);
  }

  // upload file to server
  useEffect(() => {
    if (!file && !isDemandGenerateMode && !isForecastGenerateMode) {
      setErrorMsg("Please choose a file");
      return;
    } else {
      const formData = new FormData();
      if (isDemandGenerateMode) {
        const csv = createCSV(
          demandForecast?.days,
          demandForecast?.demand,
          "demand"
        );
        formData.append("file", new Blob([csv]));
        formData.append("fileName", `${name} demand.csv`);
      } else if (isForecastGenerateMode) {
        const csv = createCSV(
          demandForecast?.days,
          demandForecast?.forecast,
          "demand"
        );
        formData.append("file", new Blob([csv]));
        formData.append("fileName", `${name} forecast.csv`);
      } else {
        formData.append("file", file);
        formData.append("fileName", file.name);
      }
      const headers = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: BEARER,
        },
      };

      axiosBaseUrl
        .post(requestPath, formData, headers)
        .then((response) => {
          redirectIfNotAuth(response);
          if (response.status === 400) {
            const msg = response.text();
            setErrorMsg(msg.substring(10, msg.length - 2));
            return;
          }
        })
        .then(() => {
          setIsShowUploadFileWindow(false);
          setIsNeedUpdateDemandForecastPlot(true);
          setIsNeedToUploadFile(false);
          setFile();
          if (isDemandGenerateMode && !isForecastGenerateMode) {
            setIsDemandGenerateMode(false);
            setIsDemandInitialMode(true);
            setIsNeedSaveGeneratedDemand(false);
          } else if (isForecastGenerateMode && !isDemandGenerateMode) {
            setIsForecastGenerateMode(false);
            setIsForecastInitialMode(true);
            setIsNeedSaveGeneratedForecast(false);
          }
          setIsNeedUpdateDemandForecastPlot(true);
          setRequestPath();
        })
        .then(() => {
          dispatch({
            type: "IS_NEED_REFRESH_SIMULATION",
            payload: true,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [
    isNeedToUploadFile,
    isNeedSaveGeneratedDemand,
    isNeedSaveGeneratedForecast,
  ]);

  // show upload file modal
  const showUploadFileWindow = (event) => {
    event.preventDefault();
    if (event.target.id === "uploadDemand") {
      setUploadTemplateTitle("Upload demand data file in csv format?");
      setUploadButtonTitle("UPLOAD DEMAND DATA, SAVE & SIMULATE");
      setRequestPath(SCENARIOS_URL + scenarioSimulateID + DEMAND_POSTFIX);
    }
    if (event.target.id === "uploadForecast") {
      setUploadTemplateTitle("Upload forecast data file in csv format?");
      setUploadButtonTitle("UPLOAD FORECAST DATA, SAVE & SIMULATE");
      setRequestPath(SCENARIOS_URL + scenarioSimulateID + FORECAST_POSTFIX);
    }
    setIsShowUploadFileWindow(true);
  };

  // hide upload file modal
  const closeUploadFileWindow = (event) => {
    event.preventDefault();
    setIsShowUploadFileWindow();
    hideAllContextButtons();
    setFile();
  };

  // flag to upload file request
  const handleUploadFile = (event) => {
    event.preventDefault();
    setIsNeedToUploadFile(true);
    setIsShowUploadFileWindow(false);
  };

  // show delete forecast modal
  const showNoForecastWindow = (event) => {
    event.preventDefault();
    setIsShowDeleteForecastWindow(true);
    setRequestPath(SCENARIOS_URL + scenarioSimulateID + FORECAST_POSTFIX);
  };

  // hide delete forecast modal
  const hideNoForecastWindow = (event) => {
    event.preventDefault();
    setIsShowDeleteForecastWindow(false);
    setRequestPath();
  };

  // flag to delete forecast request
  const submitDeleteForecast = (event) => {
    event.preventDefault();
    setIsNeedNoForecastRequest(true);
    setIsShowDeleteForecastWindow(false);
  };

  // no forecast request
  useEffect(() => {
    if (scenarioSimulateID > 0 && isNeedNoForecastRequest) {
      const pushRequest = async () => {
        try {
          const response = await fetch(requestPath, {
            method: "DELETE",
            headers: headerService(),
          }).then(() => {
            dispatch({
              type: "IS_NEED_REFRESH_SIMULATION",
              payload: true,
            });
            dispatch({
              type: "SET IS UPDATED DISTRIBUTION",
              payload: {
                isUpdatedDistribution: true,
              },
            });
          });
          if (response.status === 401) {
            navigate("/login");
          }
        } catch (error) {
          setErrorMsg(error.message);
        }
      };
      pushRequest();
      setRequestPath();
      setIsForecastInitialMode(true);
      setIsNeedUpdateDemandForecastPlot(true);
    }
  }, [isNeedNoForecastRequest]);

  // show generate demand modal
  const showGenerateDemandWindow = (event) => {
    event.preventDefault();
    setIsDemandGenerateMode(true);
    setIsDemandInitialMode(false);
    setIsShowGenerateDemandModalWindow(true);
  };

  // hide generate demand modal
  const closeGenerateDemandModalWindow = (event) => {
    event.preventDefault();
    setIsShowGenerateDemandModalWindow(false);
    setIsDemandGenerateMode(false);
    setIsDemandInitialMode(true);
    setVariability("NO");
  };

  //  handle total demand
  const handleChangeTotalDemand = (event) => {
    event.preventDefault();
    setTotalDemand(event.target.value);
  };

  // handle variability
  const handleVariability = (event) => {
    event.preventDefault();
    if (event.target.value === undefined) {
      setVariability("NO");
    } else {
      setVariability(event.target.value);
    }
  };

  // handle distribution
  const handleDemandDistribution = (event) => {
    event.preventDefault();
    setGenerateDemandRequestDTO({
      demandDistribution: event.target.id,
      totalDemand: totalDemand,
      variability: variability,
    });
    setRequestPath(SCENARIOS_URL + scenarioSimulateID + DEMAND_POSTFIX);
    setIsNeedGenerateDemandRequest(true);
    setIsShowGenerateDemandModalWindow(false);
    setIsDemandGenerateMode(true);
    setVariability("NO");
  };

  // generate demand / forecast request
  useEffect(() => {
    if (
      scenarioSimulateID > 0 &&
      (isNeedGenerateDemandRequest || isNeedGenerateForecastRequest)
    ) {
      const pushRequest = async () => {
        try {
          const response = await fetch(requestPath, {
            method: "PUT",
            headers: headerService(),
            body: JSON.stringify(generateDemandRequestDTO),
          });
          const items = await response.json();
          setDemandForecast(resolve(items));
          setMaxDemandForecastValue(findDemandForecastMaxValue(items));
          setTotalDemand(getTotalDemand(items?.demand));
          if (response.status === 401) {
            navigate("/login");
          }
        } catch (error) {
          setErrorMsg(error.message);
        }
      };
      pushRequest();
      setRequestPath();
      setIsNeedGenerateDemandRequest(false);
      setIsNeedGenerateForecastRequest(false);
    }
  }, [isNeedGenerateDemandRequest, isNeedGenerateForecastRequest]);

  // reset generated demand data
  const handleResetGeneratedDemand = (event) => {
    event.preventDefault();
    setIsNeedUpdateDemandForecastPlot(true);
    setIsDemandGenerateMode(false);
    setIsDemandInitialMode(true);
  };

  // flag to save generated demand
  const handleSaveGeneratedDemand = (event) => {
    event.preventDefault();
    setRequestPath(SCENARIOS_URL + scenarioSimulateID + DEMAND_POSTFIX);
    setIsNeedSaveGeneratedDemand(true);
  };

  // show generate forecast model
  const showGenerateForecastWindow = (event) => {
    event.preventDefault();
    setIsForecastGenerateMode(true);
    setIsForecastInitialMode(false);
    setIsShowGenerateForecastModalWindow(true);
  };

  // hide generate forecast modal
  const closeGeneratedForecastModalWindow = (event) => {
    event.preventDefault();
    setIsForecastGenerateMode(false);
    setIsForecastInitialMode(true);
    setIsShowGenerateForecastModalWindow(false);
  };

  // handle forecasting error
  const handleForecastingError = (value) => {
    setForecastingError(value);
  };

  // handle aggregation period
  const handleAggregationPeriod = (event) => {
    event.preventDefault();
    setGenerateDemandRequestDTO({
      aggregationPeriod: event.target.id,
      forecastingError: forecastingError,
    });
    setRequestPath(SCENARIOS_URL + scenarioSimulateID + FORECAST_POSTFIX);
    setIsNeedGenerateForecastRequest(true);
    setIsForecastGenerateMode(true);
    setIsShowGenerateForecastModalWindow(false);
  };

  // handle reset forecast generated data
  const handleResetGeneratedForecast = (event) => {
    event.preventDefault();
    setGenerateDemandRequestDTO({});
    setRequestPath();
    setIsNeedGenerateForecastRequest(false);
    setIsForecastGenerateMode(false);
    setIsNeedUpdateDemandForecastPlot(true);
    setIsForecastInitialMode(true);
  };

  // save generated forecast
  const handleSaveGeneratedForecast = (event) => {
    event.preventDefault();
    setRequestPath(SCENARIOS_URL + scenarioSimulateID + FORECAST_POSTFIX);
    setIsNeedSaveGeneratedForecast(true);
  };

  // get distribution
  useEffect(() => {
    if (scenarioSimulateID > 0 && isNeedDistributionRequest) {
      const path = SCENARIOS_URL + scenarioSimulateID + DISTRIBUTION_POSTFIX;
      const getRequest = async () => {
        try {
          const response = await fetch(path, {
            method: "GET",
            headers: headerService(),
          });
          const items = await response.json();
          setDistribution(parseDistribution(items));
          setCurrentDistribution(items);
          setIsInactiveDistributionMode();
          setIsUpdatedDistribution();
          if (response.status === 401) {
            navigate("/login");
          }
        } catch (error) {
          setErrorMsg(error.message);
        }
      };
      getRequest();
      setRequestPath();
      setIsNeedDistributionRequest(false);
    }
  }, [isNeedDistributionRequest]);

  // show generate distribution
  const showGenerateDistributionWindow = (event) => {
    event.preventDefault();
    setIsInactiveDistributionMode();
    setIsShowDistributionWindow(true);
  };

  // hide generate distribution
  const closeGenerateDistributionWindow = (event) => {
    event.preventDefault();
    setIsShowDistributionWindow(false);
    setRequestPath();
    setIsNeedDistributionRequest(false);
    setIsUpdatedDistribution();
    setIsInactiveDistributionMode();
  };

  // handle distribution
  const handleGenerateDistribution = (event) => {
    event.preventDefault();
  };

  // flag to send new distribution to server
  const postDistribution = (event) => {
    event.preventDefault();
    setIsNeedDistributionPostRequest(true);
    setIsShowDistributionWindow(false);
  };

  // send new distribution
  useEffect(() => {
    if (scenarioSimulateID > 0 && isNeedDistributionPostRequest) {
      const path = SCENARIOS_URL + scenarioSimulateID + DISTRIBUTION_POSTFIX;
      const getRequest = async () => {
        try {
          const response = await fetch(path, {
            method: "POST",
            headers: headerService(),
            body: JSON.stringify({
              distributionType: distribution.type,
              value: distribution.value,
              mean: distribution.mean,
              sigma: distribution.sigma,
              min: distribution.min,
              max: distribution.max,
              likely: distribution.likely,
            }),
          });
          const items = await response.json();
          setDistribution(parseDistribution(items));
          setCurrentDistribution(items);
          setIsInactiveDistributionMode();
          setIsUpdatedDistribution();
          dispatch({
            type: "IS_NEED_REFRESH_SIMULATION",
            payload: true,
          });
          if (response.status === 401) {
            navigate("/login");
          }
        } catch (error) {
          setErrorMsg(error.message);
        }
      };
      getRequest();
      setRequestPath();
      setIsNeedDistributionPostRequest(false);
    }
  }, [isNeedDistributionPostRequest]);

  const setCurrentDistribution = (dataItems) => {
    dispatch({
      type: "SET CURRENT DISTRIBUTION",
      payload: {
        type: dataItems.distributionType,
        name: dataItems.name,
        value: dataItems.value,
        mean: dataItems.mean,
        sigma: dataItems.sigma,
        min: dataItems.min,
        max: dataItems.max,
        likely: dataItems.likely,
      },
    });
  };

  const setIsUpdatedDistribution = () => {
    dispatch({
      type: "SET IS UPDATED DISTRIBUTION",
      payload: {
        isUpdatedDistribution: true,
      },
    });
  };

  const setIsInactiveDistributionMode = () => {
    dispatch({
      type: "SET IS INACTIVE DISTRIBUTION MODE",
      payload: true,
    });
  };
  return (
    <div className="property-panel">
      <div className="me-5">
        <div className="me-5">
          <h5 className="me-5">PROPERTIES</h5>
        </div>
      </div>
      <div>
        <input
          className="form-control"
          type="text"
          placeholder={ruleType}
          disabled
        ></input>
        <br />
      </div>
      <Accordion alwaysOpen>
        <Accordion.Item eventKey="-1">
          <Accordion.Header>General</Accordion.Header>
          <Accordion.Body>
            <PropertyTextArea
              id={"name"}
              title={"Name"}
              value={name}
              rows={2}
              disabled={templateSimulateID === 0 ? false : true}
              handler={(e) => handleTextAndDateFields(e)}
              error={nameError}
            />
            <PropertyDate
              id={"beginDate"}
              title={"Begin date"}
              disabled={templateSimulateID === 0 ? false : true}
              value={beginDate}
              handler={(e) => handleTextAndDateFields(e)}
              error={dateError}
            />
            <br />
            <button
              className="date-button deep-blue"
              disabled={templateSimulateID === 0 ? false : true}
              onClick={() => defineBeginDate("today")}
            >
              TODAY
            </button>
            <button
              className="date-button deep-blue"
              disabled={templateSimulateID === 0 ? false : true}
              onClick={() => defineBeginDate("thisMonth")}
            >
              THIS MONTH
            </button>
            <br />
            <PropertyDate
              id={"endDate"}
              title={"End date"}
              value={endDate}
              disabled={templateSimulateID === 0 ? false : true}
              handler={(e) => handleTextAndDateFields(e)}
              error={dateError}
            />
            <br />
            <button
              className="date-button deep-blue"
              disabled={templateSimulateID === 0 ? false : true}
              onClick={() => defineEndDate("1W")}
            >
              1W
            </button>
            <button
              className="date-button deep-blue"
              disabled={templateSimulateID === 0 ? false : true}
              onClick={() => defineEndDate("1M")}
            >
              1M
            </button>
            <button
              className="date-button deep-blue"
              disabled={templateSimulateID === 0 ? false : true}
              onClick={() => defineEndDate("1Y")}
            >
              1Y
            </button>
            <br />
            <PropertyTextArea
              id={"description"}
              title={"Description"}
              rows={3}
              value={description}
              disabled={templateSimulateID === 0 ? false : true}
              handler={(e) => handleTextAndDateFields(e)}
            />
            <PropertyDoubleInput
              id={"initialInventory"}
              title={"Initial inventory (units)"}
              value={initialInventory}
              disabled={templateSimulateID === 0 ? false : true}
              handler={(e) => handleDoubleValue(e)}
              error={initialInventoryError}
            />
          </Accordion.Body>
        </Accordion.Item>

        {ddmrpRuleFragment && (
          <Accordion.Item eventKey="0">
            <Accordion.Header>DDMRP</Accordion.Header>
            <Accordion.Body>
              <PropertyDoubleInput
                id={"zoneQuantum"}
                title={"Zone quantum"}
                value={zoneQuantum}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={zoneQuantumError}
              />
              <PropertyDoubleInput
                id={"recalculationFrequency"}
                title={"Recalculation frequency"}
                value={recalculationFrequency}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={recalculationFrequencyError}
              />
              <PropertyDoubleInput
                id={"considerationPeriod"}
                title={"Consideration period"}
                value={considerationPeriod}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={considerationPeriodError}
              />
              <PropertyDoubleInput
                id={"forwardConsideration"}
                title={"Forward consideration"}
                value={forwardConsideration}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={forwardConsiderationError}
              />
              <PropertyDoubleInput
                id={"variabilityFactor"}
                title={"Variability factor"}
                value={variabilityFactor}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={variabilityFactorError}
              />
              <PropertyDoubleInput
                id={"redZoneLeadTimeFactor"}
                title={"Red zone lead time factor"}
                value={redZoneLeadTimeFactor}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={redZoneLeadTimeFactorError}
              />
              <PropertyDoubleInput
                id={"greenZoneLeadTimeFactor"}
                title={"Green zone lead time factor"}
                value={greenZoneLeadTimeFactor}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={greenZoneLeadTimeFactorError}
              />
              <PropertyCheckInput
                id={"isConsiderPreOrders"}
                title={"Consider pre orders"}
                disabled={templateSimulateID === 0 ? false : true}
                value={isConsiderPreOrders}
                handler={(e) => handleCheckValue(e)}
              />
              <PropertyDoubleInput
                id={"qualifiedSpikeHorizon"}
                title={"Qualified spike horizon"}
                value={qualifiedSpikeHorizon}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={qualifiedSpikeHorizonError}
              />
              <PropertyDoubleInput
                id={"qualifiedSpikeSizeFractionTopOfRed"}
                title={"Qualified spike size fraction top of red"}
                value={qualifiedSpikeSizeFractionTopOfRed}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={qualifiedSpikeSizeFractionTopOfRedError}
              />
              <PropertyCheckInput
                id={"isRecalculateDLT"}
                title={"Recalculate DLT"}
                disabled={templateSimulateID === 0 ? false : true}
                value={isRecalculateDLT}
                handler={(e) => handleCheckValue(e)}
              />
              <PropertyDoubleInput
                id={"dltRecalculationHorizonDLTs"}
                title={"DLT recalculation horizon, DLTs"}
                value={dltRecalculationHorizonDLTs}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={dltRecalculationHorizonDLTsError}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}

        {consumptionTocRuleFragment && (
          <Accordion.Item eventKey="1">
            <Accordion.Header>Consumption</Accordion.Header>
            <Accordion.Body>
              <PropertyEnumInput
                id={"consumptionAggregationType"}
                title={"Consumption aggregation type"}
                selectedValue={consumptionAggregationType}
                disabled={templateSimulateID === 0 ? false : true}
                values={[
                  {
                    value:
                      PROPERTY_LIMITATIONS.CONSUMPTION_AGGREGATION_TYPE_AVERAGE,
                  },
                  {
                    value:
                      PROPERTY_LIMITATIONS.CONSUMPTION_AGGREGATION_TYPE_MAX,
                  },
                ]}
                handler={(e) => handleEnumValues(e)}
              />
              <PropertyDoubleInput
                id={"consumptionTimeWindowRRTs"}
                title={"Consumption time window, RRTs"}
                value={consumptionTimeWindowRRTs}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={consumptionTimeWindowRRTsError}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}

        {penetrationTocWithSmallTslRuleFragment && (
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              Penetration-based with small TSL calculation
            </Accordion.Header>
            <Accordion.Body>
              <PropertyDoubleInput
                id={"useRedDaysBasedRuleForTSLBelow"}
                title={"Use red days based rule for TSL below"}
                value={useRedDaysBasedRuleForTSLBelow}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={useRedDaysBasedRuleForTSLBelowError}
              />
              <PropertyDoubleInput
                id={"redDaysBackwardLookingHorizonRRTs"}
                title={"Red days backward looking horizon, RRTs"}
                value={redDaysBackwardLookingHorizonRRTs}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={redDaysBackwardLookingHorizonRRTsError}
              />
              <PropertyDoubleInput
                id={"redDaysNumberToIncreaseTSL"}
                title={"Red days number to increase TSL"}
                value={redDaysNumberToIncreaseTSL}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={redDaysNumberToIncreaseTSLError}
              />
              <PropertyDoubleInput
                id={"greenPeriodToDecreaseTSLRRTs"}
                title={"Green period to decrease TSL, RRTs"}
                value={greenPeriodToDecreaseTSLRRTs}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={greenPeriodToDecreaseTSLRRTsError}
              />
              <PropertyDoubleInput
                id={"waitingPeriodBeforeCheckingToIncreaseTSLRRTs"}
                title={"Waiting period before checking to increase TSL, RRTs"}
                value={waitingPeriodBeforeCheckingToIncreaseTSLRRTs}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={waitingPeriodBeforeCheckingToIncreaseTSLRRTsError}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}

        {penetrationTocRuleFragment && (
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              Penetration-based TSL calculation
            </Accordion.Header>
            <Accordion.Body>
              <PropertyDoubleInput
                id={"targetBufferIncreasePercent"}
                title={"Target buffer increase percent"}
                value={targetBufferIncreasePercent}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={targetBufferIncreasePercentError}
              />
              <PropertyDoubleInput
                id={"targetBufferDecreasePercent"}
                title={"Target buffer decrease percent"}
                value={targetBufferDecreasePercent}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={targetBufferDecreasePercentError}
              />
              <PropertyDoubleInput
                id={"redSlidingWindowSizeInRRTs"}
                title={"Red sliding window size, RRTs"}
                value={redSlidingWindowSizeInRRTs}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={redSlidingWindowSizeInRRTsError}
              />
              <PropertyDoubleInput
                id={"greenSlidingWindowSizeInRRTs"}
                title={"Green sliding window size, RRTs"}
                value={greenSlidingWindowSizeInRRTs}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={greenSlidingWindowSizeInRRTsError}
              />
              <PropertyDoubleInput
                id={"redToleranceTimeInRRTs"}
                title={"Red tolerance time, RRTs"}
                value={redToleranceTimeInRRTs}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={redToleranceTimeInRRTsError}
              />
              <PropertyDoubleInput
                id={"redPenetrationThreshold"}
                title={"Red penetration threshold"}
                value={redPenetrationThreshold}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={redPenetrationThresholdError}
              />
              <PropertyEnumInput
                id={"redPenetrationCountingCriteria"}
                title={"Red penetration counting criteria"}
                selectedValue={redPenetrationCountingCriteria}
                disabled={templateSimulateID === 0 ? false : true}
                values={[
                  {
                    value:
                      PROPERTY_LIMITATIONS.RED_PENETRATION_COUNTING_CRITERIA_TIME_OR_ORDER_ARRIVAL,
                  },
                  {
                    value:
                      PROPERTY_LIMITATIONS.RED_PENETRATION_COUNTING_CRITERIA_TIME_AND_ORDER_ARRIVAL,
                  },
                ]}
                handler={(e) => handleEnumValues(e)}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}

        {tocRuleFragment && (
          <Accordion.Item eventKey="4">
            <Accordion.Header>Hybrid parameters</Accordion.Header>
            <Accordion.Body>
              <PropertyCheckInput
                id={"isUseHybridRule"}
                title={"Use hybrid rule"}
                value={isUseHybridRule}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleCheckValue(e)}
              />
              <PropertyDoubleInput
                id={"hybridAdjustmentHorizonRRTs"}
                title={"Hybrid adjustment horizon, RRTs"}
                value={hybridAdjustmentHorizonRRTs}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={hybridAdjustmentHorizonRRTsError}
              />
              <PropertyDoubleInput
                id={"hybridIncreaseThreshold"}
                title={"Hybrid increase threshold"}
                value={hybridIncreaseThreshold}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={hybridIncreaseThresholdError}
              />
              <PropertyDoubleInput
                id={"hybridDecreaseThreshold"}
                title={"Hybrid decrease threshold"}
                value={hybridDecreaseThreshold}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={hybridDecreaseThresholdError}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}

        {tocRuleFragment && (
          <Accordion.Item eventKey="5">
            <Accordion.Header>Initial TSL parameters</Accordion.Header>
            <Accordion.Body>
              <PropertyEnumInput
                id={"initialTSLCalculationRuleType"}
                title={"Initial TSL calculation rule"}
                selectedValue={initialTSLCalculationRuleType}
                disabled={templateSimulateID === 0 ? false : true}
                values={[
                  {
                    value:
                      PROPERTY_LIMITATIONS.INITIAL_TSL_CALCULATION_RULE_TYPE_FORECAST_WITHIN_PERIOD,
                  },
                  {
                    value:
                      PROPERTY_LIMITATIONS.INITIAL_TSL_CALCULATION_RULE_TYPE_ACTUAL_INVENTORY,
                  },
                ]}
                handler={(e) => handleEnumValues(e)}
              />
              <PropertyEnumInput
                id={"initialTSLCalculationAggregationType"}
                title={"Aggregation type"}
                selectedValue={initialTSLCalculationAggregationType}
                disabled={templateSimulateID === 0 ? false : true}
                values={[
                  {
                    value:
                      PROPERTY_LIMITATIONS.INITIAL_TSL_CALCULATION_AGGREGATION_TYPE_AVERAGE,
                  },
                  {
                    value:
                      PROPERTY_LIMITATIONS.INITIAL_TSL_CALCULATION_AGGREGATION_TYPE_MAX,
                  },
                ]}
                handler={(e) => handleEnumValues(e)}
              />
              <PropertyDoubleInput
                id={"initialTSLCalculationWindowSizeRRTs"}
                title={"Initial TSL calculation window, RRTs"}
                value={initialTSLCalculationWindowSizeRRTs}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={initialTSLCalculationWindowSizeRRTsError}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}

        {tocRuleFragment && (
          <Accordion.Item eventKey="6">
            <Accordion.Header>Advanced parameters</Accordion.Header>
            <Accordion.Body>
              <PropertyDoubleInput
                id={"tslRedLevel"}
                title={"TSL Red level"}
                value={tslRedLevel}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={tslRedLevelError}
              />
              <PropertyDoubleInput
                id={"tslYellowLevel"}
                title={"TSL Yellow level"}
                value={tslYellowLevel}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={tslYellowLevelError}
              />
              <PropertyDoubleInput
                id={"absoluteMinimumTSL"}
                title={"Absolute minimum TSL, units"}
                value={absoluteMinimumTSL}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={absoluteMinimumTSLError}
              />
              <PropertyDoubleInput
                id={"tslRoundingMultiple"}
                title={"TSL rounding multiple, units"}
                value={tslRoundingMultiple}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={tslRoundingMultipleError}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}

        {ruleFragment && (
          <Accordion.Item eventKey="7">
            <Accordion.Header>Ordering parameters</Accordion.Header>
            <Accordion.Body>
              <PropertyDoubleInput
                id={"orderingFrequency"}
                title={"Ordering frequency, days"}
                value={orderingFrequency}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={orderingFrequencyError}
              />
              <PropertyDoubleInput
                id={"minOrderQuantity"}
                title={"Min order quantity, units"}
                value={minOrderQuantity}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={minOrderQuantityError}
              />
              <PropertyDoubleInput
                id={"orderingQuantum"}
                title={"Ordering quantum, units"}
                value={orderingQuantum}
                disabled={templateSimulateID === 0 ? false : true}
                handler={(e) => handleDoubleValue(e)}
                error={orderingQuantumError}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}
        <Accordion.Item eventKey="-3">
          <Accordion.Header>UpStream</Accordion.Header>
          <Accordion.Body>
            <p>Lead time, days</p>

            <div>
              {currentDistribution?.name && (
                <span>
                  {currentDistribution.type} :{" "}
                  {currentDistribution.name.substring(
                    currentDistribution.name.indexOf("(")
                  )}
                </span>
              )}
            </div>
            <SmallButton
              cssStyle={"small-button deep-blue"}
              disabled={templateSimulateID == 0 ? false : true}
              handler={(e) => showGenerateDistributionWindow(e)}
              buttonText={"SELECT DISTRIBUTION"}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="-2">
          <Accordion.Header>DownStream</Accordion.Header>
          <Accordion.Body>
            <p>Total demand</p>
            <p>{totalDemandString}</p>
            {isDemandGenerateMode ? (
              <p>Generated demand data</p>
            ) : (
              <p>Demand data from scenario</p>
            )}
            <SmallButton
              disabled={
                !isDemandInitialMode ||
                isDemandGenerateMode ||
                templateSimulateID !== 0 ||
                isForecastGenerateMode
              }
              cssStyle={"small-button deep-blue"}
              handler={(e) => handleDownloadDemandFile(e)}
              buttonText={
                isDemandGenerateMode ? (
                  <>DOWNLOAD GENERATED</>
                ) : (
                  <>DOWNLOAD FROM SCENARIO</>
                )
              }
            />

            <SmallButton
              id={"uploadDemand"}
              disabled={
                isDemandGenerateMode ||
                templateSimulateID !== 0 ||
                isForecastGenerateMode
              }
              cssStyle={"small-button deep-blue"}
              handler={(e) => showUploadFileWindow(e)}
              buttonText={"UPLOAD FROM FILE TO SCENARIO"}
            />

            <br />
            <SmallButton
              disabled={
                !isDemandInitialMode ||
                isDemandGenerateMode ||
                templateSimulateID !== 0 ||
                isForecastGenerateMode
              }
              cssStyle={"small-button yellow"}
              handler={(e) => showGenerateDemandWindow(e)}
              buttonText={"GENERATE"}
            />
            <SmallButton
              disabled={
                !isDemandGenerateMode ||
                templateSimulateID !== 0 ||
                isForecastGenerateMode
              }
              cssStyle={"small-button grey"}
              handler={(e) => handleResetGeneratedDemand(e)}
              buttonText={"RESET GENERATED"}
            />
            <SmallButton
              disabled={
                !isDemandGenerateMode ||
                templateSimulateID !== 0 ||
                isForecastGenerateMode
              }
              cssStyle={"small-button green"}
              handler={(e) => handleSaveGeneratedDemand(e)}
              buttonText={"SAVE GENERATED"}
            />
            <br />
            <hr />
            {isForecastGenerateMode ? (
              <p>Generated forecast data</p>
            ) : (
              <p>Forecast data from scenario</p>
            )}
            <SmallButton
              disabled={
                !isForecastInitialMode ||
                isForecastGenerateMode ||
                templateSimulateID !== 0 ||
                isDemandGenerateMode
              }
              cssStyle={"small-button deep-blue"}
              handler={(e) => handleDownloadForecastFile(e)}
              buttonText={
                isForecastGenerateMode ? (
                  <>DOWNLOAD GENERATED</>
                ) : (
                  <>DOWNLOAD FROM SCENARIO</>
                )
              }
            />
            <SmallButton
              id={"uploadForecast"}
              disabled={
                isForecastGenerateMode ||
                templateSimulateID !== 0 ||
                isDemandGenerateMode
              }
              cssStyle={"small-button deep-blue"}
              handler={(e) => showUploadFileWindow(e)}
              buttonText={"UPLOAD FROM FILE TO SCENARIO"}
            />
            <br />
            <SmallButton
              id={"uploadForecast"}
              disabled={
                !isForecastInitialMode ||
                isForecastGenerateMode ||
                templateSimulateID !== 0 ||
                isDemandGenerateMode
              }
              cssStyle={"small-button yellow"}
              handler={(e) => showGenerateForecastWindow(e)}
              buttonText={"GENERATE"}
            />

            <SmallButton
              disabled={
                !isForecastGenerateMode ||
                templateSimulateID !== 0 ||
                isDemandGenerateMode
              }
              cssStyle={"small-button grey"}
              handler={(e) => handleResetGeneratedForecast(e)}
              buttonText={"RESET GENERATED"}
            />

            <br />
            <SmallButton
              disabled={
                !isForecastGenerateMode ||
                templateSimulateID !== 0 ||
                isDemandGenerateMode
              }
              cssStyle={"small-button green"}
              handler={(e) => handleSaveGeneratedForecast(e)}
              buttonText={"SAVE GENERATED"}
            />

            <SmallButton
              disabled={
                isForecastGenerateMode ||
                templateSimulateID !== 0 ||
                isDemandGenerateMode
              }
              cssStyle={"small-button red"}
              handler={(e) => showNoForecastWindow(e)}
              buttonText={"NO FORECAST"}
            />

            {demandForecast && (
              <div style={{ width: 220 }}>
                <DemandForecastChart
                  plotData={demandForecast}
                  maxChartValue={maxDemandForecastValue}
                />
              </div>
            )}
          </Accordion.Body>
        </Accordion.Item>
        <br />
        <br />
      </Accordion>
      <ModalUploadFile
        onHide={(e) => closeUploadFileWindow(e)}
        isShowWindow={isShowUploadFileWindow}
        title={uploadTemplateTitle}
        handleSubmit={(e) => handleUploadFile(e)}
        handleChooseFile={(e) => handleChooseFile(e)}
        isActiveUploadFileButton={file}
        buttonTittle={uploadButtonTitle}
      />
      <ModalDelete
        onHide={(e) => hideNoForecastWindow(e)}
        isShowWindow={isShowDeleteForecastWindow}
        handleDelete={(e) => submitDeleteForecast(e)}
        title={DELETE_FORECAST}
        buttonTittle={DELETE_BUTTON_TITLE}
      />

      <ModalGenerateDemand
        onHide={(e) => closeGenerateDemandModalWindow(e)}
        isShowWindow={isShowGenerateDemandModalWindow}
        handleVariability={(e) => handleVariability(e)}
        handleDistribution={(e) => handleDemandDistribution(e)}
        totalDemand={(e) => handleChangeTotalDemand(e)}
        totalDemandOldValue={totalDemand}
        days={days}
        title={GENERATE_DEMAND}
      />
      <ModalGenerateForecast
        onHide={(e) => closeGeneratedForecastModalWindow(e)}
        isShowWindow={isShowGenerateForecastModalWindow}
        handleForecastingError={(f, t) => handleForecastingError(f, t)}
        handleAggregationPeriod={(e) => handleAggregationPeriod(e)}
        title={GENERATE_FORECAST}
      />
      <ModalGenerateDistribution
        onHide={(e) => closeGenerateDistributionWindow(e)}
        distribution={distribution}
        setDistribution={setDistribution}
        postDistribution={postDistribution}
        isShowWindow={isShowDistributionWindow}
        title="Lead time distribution"
        handle={(e) => handleGenerateDistribution(e)}
      />
    </div>
  );
};

export default PropertyPanel;
